{
  "user": {
    "form": {
      "addTitle": "பயனரை உருவாக்கவும்",
      "editTitle": "பயனரைத் திருத்தவும்",
      "fields": {
        "username": "பயனர் பெயர்",
        "email": "மின்னஞ்சல்",
        "fullName": "முழுப் பெயர்",
        "password": "கடவுச்சொல்",
        "confirmPassword": "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        "facility": "மருத்துவ நிலையம்",
        "roles": "பாத்திரங்கள்",
        "active": "செயலில்",
        "allFacilities": "அனைத்து மையங்களும் (சுகாதார அமைப்பு முழுவதும்)",
        "globalAccessAck": "இது ஒவ்வொரு மையத்திற்கும் அணுகல் வழங்குகிறது என்பதை நான் புரிந்துகொள்கிறேன்",
        "departments": "துறைகள்",
        "primaryDepartment": "முதன்மை",
        "roleFacility": "{{role}} க்கான நிலையம்",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ மற்றொரு நிலையம்",
        "removeFacilityFromRole": "ஒன்றை நீக்கு",
        "otherRoles": "பிற"
      },
      "errors": {
        "usernameMin": "பயனர் பெயர் குறைந்தது {{min}} எழுத்துகள் கொண்டிருக்க வேண்டும்",
        "emailInvalid": "மின்னஞ்சல் முகவரி தவறானது",
        "passwordMin": "கடவுச்சொல் குறைந்தது {{min}} எழுத்துகள் கொண்டிருக்க வேண்டும்",
        "confirmPasswordRequired": "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        "passwordMismatch": "கடவுச்சொற்கள் பொருந்தவில்லை",
        "rolesRequired": "குறைந்தது ஒரு பாத்திரம் தேவை",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "சேமிப்பதற்கு முன் சுகாதார அமைப்பு முழுவதுமான அனுமதியை உறுதிப்படுத்தவும்."
      },
      "submit": {
        "create": "பயனரை உருவாக்கவும்",
        "update": "பயனரைப் புதுப்பிக்கவும்"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "பயனர் வெற்றிகரமாக உருவாக்கப்பட்டார்",
        "updatedSuccess": "பயனர் வெற்றிகரமாகப் புதுப்பிக்கப்பட்டார்",
        "saveError": "பயனரைச் சேமிக்க இயலவில்லை",
        "departmentsSaveError": "பயனர் சேமிக்கப்பட்டார், ஆனால் துறை ஒதுக்கீடு தோல்வியடைந்தது. மீண்டும் முயல திருத்தவும்."
      },
      "globalAccessWarning": "இது அழைப்பு வரம்பை மட்டுமல்ல, ஒவ்வொரு மையத்திலும் உள்ள நோயாளிகளுக்கான அணுகலை வழங்குகிறது. உண்மையிலேயே சுகாதார அமைப்பு முழுவதும் பணியாற்றும் ஊழியர்களுக்கு மட்டுமே பயன்படுத்தவும்.",
      "departmentsHint": "இந்தக் கணக்கு பணியாற்றும் துறை. இது சூழல் மற்றும் பதிவுக்கு மட்டுமே — எந்த நோயாளிக்கும் அணுகல் வழங்காது.",
      "noDepartments": "இதுவரை எந்தத் துறையும் அமைக்கப்படவில்லை."
    },
    "list": {
      "title": "பயனர் மேலாண்மை",
      "subtitle": "கணினி பயனர்கள், பாத்திரங்கள் மற்றும் அணுகலை நிர்வகி",
      "columns": {
        "username": "பயனர்பெயர்",
        "fullName": "முழுப் பெயர்",
        "email": "மின்னஞ்சல்",
        "roles": "பாத்திரங்கள்",
        "facility": "வசதி",
        "status": "நிலை",
        "lastLogin": "கடைசி உள்நுழைவு",
        "actions": "செயல்கள்",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "பயனர்களைத் தேடு...",
        "allRoles": "அனைத்து பாத்திரங்கள்",
        "allFacilities": "அனைத்து வசதிகள்",
        "allStatus": "அனைத்து நிலைகள்",
        "active": "செயலில்",
        "inactive": "செயலில் இல்லை"
      },
      "actions": {
        "new": "பயனரை உருவாக்கவும்",
        "editTitle": "பயனரைத் திருத்தவும்",
        "resetPasswordTitle": "கடவுச்சொல்லை மீட்டமை",
        "activate": "செயல்படுத்து",
        "deactivate": "செயலிழக்கச் செய்",
        "activateAria": "பயனரைச் செயல்படுத்து",
        "deactivateAria": "பயனரைச் செயலிழக்கச் செய்"
      },
      "lastLoginNever": "ஒருபோதும் இல்லை",
      "empty": "உங்கள் வடிகட்டிக்குப் பொருந்தும் பயனர்கள் இல்லை",
      "pagination": {
        "summary": "{{total}} இல் {{from}}-{{to}} காட்டப்படுகிறது"
      },
      "toast": {
        "activated": "பயனர் {{username}} செயல்படுத்தப்பட்டார்",
        "deactivated": "பயனர் {{username}} செயலிழக்கச் செய்யப்பட்டார்",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "அனைத்து மையங்களும்",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "செயலில்",
      "inactive": "செயலில் இல்லை",
      "locked": "பூட்டப்பட்டது",
      "pendingActivation": "செயல்படுத்துதலுக்காக காத்திருக்கிறது"
    },
    "mfaStatus": {
      "enrolled": "பதிவு செய்யப்பட்டது",
      "notEnrolled": "பதிவு செய்யப்படவில்லை",
      "exempt": "விலக்கு"
    }
  },
  "role": {
    "form": {
      "addTitle": "பாத்திரத்தை உருவாக்கவும்",
      "editTitle": "பாத்திரத்தைத் திருத்தவும்",
      "fields": {
        "name": "பாத்திரப் பெயர்",
        "code": "பாத்திரக் குறியீடு",
        "description": "விளக்கம்",
        "category": "வகை",
        "parentRole": "முதன்மை பாத்திரம் (அனுமதிகளைப் பெறுகிறது)"
      },
      "options": {
        "none": "எதுவும் இல்லை"
      },
      "errors": {
        "nameRequired": "பாத்திரப் பெயர் தேவை",
        "codeRequired": "பாத்திரக் குறியீடு தேவை"
      },
      "submit": {
        "create": "பாத்திரத்தை உருவாக்கவும்",
        "update": "பாத்திரத்தைப் புதுப்பிக்கவும்"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "பாத்திரம் வெற்றிகரமாக உருவாக்கப்பட்டது",
        "updatedSuccess": "பாத்திரம் வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது",
        "saveError": "பாத்திரத்தைச் சேமிக்க இயலவில்லை"
      }
    },
    
    "status": {
      "active": "செயலில்",
      "inactive": "செயலில் இல்லை"
    },
    "source": {
      "own": "சொந்தம்",
      "inherited": "பெறப்பட்டது",
      "category": "வகை"
    },
    "permissions": {
      "ownTitle": "அனுமதிகளைத் திருத்தவும்",
      "deniedTitle": "மறுக்கப்பட்ட அனுமதிகளைத் திருத்தவும்",
      "ownSubtitle": "{{total}}-இல் {{granted}} வழங்கப்பட்டுள்ளது. பெறுபட்ட மற்றும் வகை-இயல்புநிலை அனுமதிகள் அணுகல் மேட்ரிக்ஸில் காட்டப்படுகின்றன; இந்தப் பக்கம் பாத்திரத்தின் சொந்த வழங்கல்களை மட்டுமே நிர்வகிக்கிறது.",
      "deniedSubtitle": "மறுக்கப்பட்ட அனுமதிகள் பாத்திரத்தின் சொந்த அனுமதிகள், அதன் முதன்மை பாத்திரங்கள், மற்றும் வகை இயல்புநிலைகளில் இருந்து வழங்கல்களை மீறுகின்றன. இந்தப் பாத்திரத்திற்கு வெளிப்படையாக மறுக்க அனுமதியைத் தேர்வுசெய்க.",
      "invalidRoleId": "பாத்திர ID செல்லாதது.",
      "save": "அனுமதிகளைச் சேமிக்கவும்",
      "saveDenied": "மறுக்கப்பட்ட அனுமதிகளைச் சேமிக்கவும்",
      "cancel": "ரத்து செய்",
      "toast": {
        "updatedSuccess": "அனுமதிகள் புதுப்பிக்கப்பட்டன",
        "deniedUpdatedSuccess": "மறுக்கப்பட்ட அனுமதிகள் புதுப்பிக்கப்பட்டன",
        "saveError": "அனுமதிகளைச் சேமிக்க இயலவில்லை",
        "saveDeniedError": "மறுக்கப்பட்ட அனுமதிகளைச் சேமிக்க இயலவில்லை"
      },
      "permissionGroup": {
        "analytics": "பகுப்பாய்வு",
        "audit": "தணிக்கை",
        "billing": "கட்டணம்",
        "bloodProduct": "இரத்த தயாரிப்புகள்",
        "consent": "ஒப்புதல்",
        "dietOrder": "உணவு ஆர்டர்",
        "discharge": "வீடு திரும்புதல்",
        "documentation": "ஆவணப்படுத்தல்",
        "encounter": "சந்திப்பு",
        "infection": "தொற்றுக் கட்டுப்பாடு",
        "licensing": "உரிமம்",
        "medication": "மருந்துகள்",
        "notification": "அறிவிப்புகள்",
        "order": "ஆர்டர்கள்",
        "patient": "நோயாளி",
        "referral": "பரிந்துரை",
        "research": "ஆராய்ச்சி",
        "restraint": "கட்டுப்பாடு",
        "result": "முடிவுகள்",
        "scheduling": "கால அட்டவணை",
        "system": "முறைமை",
        "transfer": "இடமாற்றம்",
        "user": "பயனர்கள்",
        "schedule": "அட்டவணை",
        "admin": "நிர்வாகம்",
        "report": "அறிக்கைகள்",
        "other": "மற்றவை"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "வகையை உருவாக்கவும்",
      "editTitle": "வகையைத் திருத்தவும்",
      "fields": {
        "name": "வகையின் பெயர்",
        "code": "வகை குறியீடு",
        "description": "விளக்கம்",
        "sessionTimeout": "அமர்வு காலாவதி (நிமிடங்கள்)",
        "maxFailedLogins": "அதிகபட்ச தோல்வியான உள்நுழைவுகள்",
        "mfaRequired": "இந்த வகைக்கு MFA கட்டாயம்"
      },
      "placeholders": {
        "code": "எ.கா. CLINICAL"
      },
      "errors": {
        "nameRequired": "வகையின் பெயர் தேவை",
        "codeRequired": "வகை குறியீடு தேவை"
      },
      "submit": {
        "create": "வகையை உருவாக்கவும்",
        "update": "வகையைப் புதுப்பிக்கவும்"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "வகை உருவாக்கப்பட்டது",
        "updatedSuccess": "வகை புதுப்பிக்கப்பட்டது",
        "saveError": "வகையைச் சேமிக்க முடியவில்லை"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "எதுவுமில்லை",
      "basic": "அடிப்படை",
      "full": "முழுமை",
      "paranoid": "மிக கடுமை"
    },
    "permissions": {
      "title": "இயல்புநிலை அனுமதிகள்",
      "titleWithName": "இயல்புநிலை அனுமதிகள் — {{name}}",
      "subtitle": "இந்த வகையில் உள்ள பாத்திரங்கள் வெளிப்படையாக மறுக்கப்படாவிட்டால் இந்த அனுமதிகளைப் பெறுகின்றன.",
      "invalidCategoryId": "வகை ID செல்லுபடியாகவில்லை.",
      "save": "இயல்புநிலை அனுமதிகளைச் சேமி",
      "cancel": "ரத்து செய்",
      "toast": {
        "updatedSuccess": "இயல்புநிலை அனுமதிகள் புதுப்பிக்கப்பட்டன",
        "saveError": "இயல்புநிலை அனுமதிகளைச் சேமிக்க முடியவில்லை"
      }
    }
  },
  "permission": {
    "action": {
      "view": "பார்வை",
      "viewSelf": "சொந்தம் மட்டும் பார்வை",
      "viewRestricted": "வரம்புள்ள பார்வை",
      "read": "படிக்கவும்",
      "write": "எழுதவும்",
      "create": "உருவாக்கவும்",
      "update": "புதுப்பிக்கவும்",
      "modify": "மாற்றவும்",
      "delete": "நீக்கவும்",
      "merge": "ஒன்றிணைக்கவும்",
      "discharge": "வீடு திரும்புதல்",
      "transfer": "இடமாற்றம்",
      "approve": "ஒப்புதல்",
      "cosign": "இணை கையொப்பம்",
      "sign": "கையொப்பம்",
      "plan": "திட்டமிடல்",
      "manage": "நிர்வாகம்",
      "all": "அனைத்தும்",
      "breakGlass": "அவசர அணுகல்",
      "export": "ஏற்றுமதி",
      "amend": "திருத்தம்",
      "administer": "வழங்குதல்",
      "doubleCheck": "இரட்டை சோதனை",
      "reconcile": "சரிசெய்தல்",
      "verbalVerify": "வாய்வழி ஆர்டர் உறுதி",
      "verify": "சரிபார்த்தல்",
      "acknowledge": "ஏற்றுக்கொள்ளுதல்",
      "prescribe": "மருந்துச்சீட்டு",
      "dispense": "வழங்கல்",
      "cancel": "ரத்து செய்",
      "users": "பயனர்கள்",
      "roles": "பாத்திரங்கள்",
      "facilities": "மருத்துவ நிலையங்கள்",
      "system": "முறைமை",
      "audit": "தணிக்கை பதிவு"
    }
  },
  "access": {
    "title": "அணுகல் அணி",
    "subtitle": "பாத்திரங்கள் × அனுமதிகள் கட்டம்",
    "searchPermission": "அனுமதிகளைத் தேடு…",
    "searchRole": "பாத்திரங்களைத் தேடு…",
    "categoryFilter": "வகை",
    "legend": {
      "own": "சொந்த",
      "inherited": "மரபுரிமை",
      "category": "வகை",
      "denied": "மறுக்கப்பட்டது",
      "none": "எதுவுமில்லை"
    },
    "cellTooltip": {
      "hasOwn": "நேரடியாக வழங்கப்பட்டது",
      "hasInherited": "பெற்றோர் பாத்திரத்திலிருந்து மரபுரிமை: {{source}}",
      "hasCategory": "வகை வழியாக வழங்கப்பட்டது: {{source}}",
      "denied": "வெளிப்படையாக மறுக்கப்பட்டது",
      "none": "வழங்கப்படவில்லை"
    },
    "inheritedFrom": "{{source}} இலிருந்து மரபுரிமை",
    "bulkEdit": {
      "title": "மொத்த திருத்தம்",
      "applyTo": "தேர்ந்தெடுக்கப்பட்டவற்றில் பயன்படுத்து",
      "selectedPermissions": "{{count}} அனுமதி(கள்)",
      "selectedRoles": "{{count}} பாத்திரம்(ங்கள்)",
      "actionGrant": "வழங்கு",
      "actionDeny": "மறு",
      "actionClear": "அழி",
      "save": "மாற்றங்களைச் சேமி",
      "cancel": "ரத்து செய்"
    },
    "emptyRoles": "வடிகட்டிக்கு பொருந்தும் பாத்திரங்கள் எதுவுமில்லை.",
    "emptyPermissions": "வடிகட்டிக்கு பொருந்தும் அனுமதிகள் எதுவுமில்லை.",
    "loading": "அணுகல் அணி ஏற்றப்படுகிறது…",
    "permissionColumn": "அனுமதி",
    "rolePicker": {
      "trigger": "ஒப்பிட பாத்திரங்களைத் தேர்ந்தெடு",
      "filterPlaceholder": "பாத்திரங்களை வடிகட்டு…",
      "empty": "பொருந்தும் பாத்திரம் இல்லை.",
      "groupAll": "அனைத்தும்",
      "groupNone": "எதுவுமில்லை",
      "footerSummary": "{{total}} இல் {{count}} தேர்ந்தெடுக்கப்பட்டது",
      "selectAll": "அனைத்தையும் தேர்ந்தெடு",
      "clear": "அழி"
    },
    "empty": {
      "selectRolesPrompt": "ஒப்பிட குறைந்தது ஒரு பாத்திரத்தைத் தேர்ந்தெடுக்கவும்.",
      "selectAllRoles": "அனைத்து பாத்திரங்களையும் தேர்ந்தெடு",
      "noPermissions": "அனுமதிகள் எதுவும் கிடைக்கவில்லை."
    },
    "legendCategoryDefault": "வகை இயல்புநிலை",
    "legendNotGranted": "வழங்கப்படவில்லை",
    "page": {
      "title": "அணுகல் அணி",
      "subtitle": "பாத்திரங்கள், அனுமதிகள் மற்றும் அணுகல் கொள்கைகளைப் பார்த்து நிர்வகி"
    },
    "tabs": {
      "matrix": "அணுகல் அணி",
      "roles": "பாத்திர நிர்வாகம்",
      "categories": "வகை நிர்வாகம்"
    },
    "roles": {
      "searchPlaceholder": "பாத்திரங்கள் அல்லது அனுமதிகளைத் தேடு...",
      "createButton": "பாத்திரத்தை உருவாக்கு",
      "columns": {
        "role": "பாத்திரம்",
        "category": "வகை",
        "parent": "பெற்றோர் பாத்திரம்",
        "permissions": "அனுமதிகள்",
        "users": "பயனர்கள்",
        "actions": "செயல்கள்"
      },
      "systemBadge": "முறைமை",
      "managePermissionsTitle": "அனுமதிகளை நிர்வகி",
      "manageDeniedTitle": "மறுக்கப்பட்ட அனுமதிகளை நிர்வகி",
      "deniedBadge": "மறுக்கப்பட்டது",
      "editTitle": "பாத்திரத்தைத் திருத்து",
      "deleteTitle": "பாத்திரத்தை நீக்கு",
      "expandAria": "பாத்திரத்தை விரிவாக்கு",
      "collapseAria": "பாத்திரத்தை சுருக்கு",
      "effectivePermissions": "செயல்திறன் அனுமதிகள்",
      "noPermissionsAssigned": "அனுமதிகள் எதுவும் ஒதுக்கப்படவில்லை.",
      "empty": "பாத்திரங்கள் எதுவும் கிடைக்கவில்லை.",
      "delete": {
        "title": "பாத்திரத்தை நீக்கு",
        "description": "\"{{name}}\" பாத்திரத்தை நீக்க விரும்புகிறீர்களா? இந்தச் செயலை மீட்டெடுக்க முடியாது.",
        "confirm": "நீக்கு"
      },
      "toast": {
        "deleted": "பாத்திரம் நீக்கப்பட்டது",
        "deleteError": "பாத்திரத்தை நீக்க முடியவில்லை"
      }
    },
    "categories": {
      "subtitle": "வகைகள் பாத்திரங்களை குழுவாக்கி, பகிரப்பட்ட கொள்கைகளை (MFA, அமர்வு வரம்புகள்) வரையறுக்கின்றன.",
      "createButton": "வகையை உருவாக்கு",
      "requireMfa": "MFA தேவை",
      "yes": "ஆம்",
      "no": "இல்லை",
      "sessionTimeout": "அமர்வு காலாவதி",
      "sessionTimeoutMinutes": "{{count}} நிமிடம்",
      "maxFailedLogins": "அதிகபட்ச தோல்வி உள்நுழைவுகள்",
      "manageDefaults": "இயல்புநிலை அனுமதிகளை நிர்வகி",
      "editTitle": "திருத்து",
      "editAria": "வகையைத் திருத்து",
      "deleteTitle": "நீக்கு",
      "deleteAria": "வகையை நீக்கு",
      "empty": "இன்னும் வகைகள் எதுவும் வரையறுக்கப்படவில்லை.",
      "delete": {
        "title": "வகையை நீக்கு",
        "description": "\"{{name}}\" வகையை நீக்க விரும்புகிறீர்களா? இந்தச் செயலை மீட்டெடுக்க முடியாது.",
        "confirm": "நீக்கு"
      },
      "toast": {
        "deleted": "வகை நீக்கப்பட்டது",
        "deleteError": "வகையை நீக்க முடியவில்லை"
      }
    },
    "confirm": {
      "bulkApply": "{{count}} மாற்றத்தை {{roleCount}} பாத்திரத்திற்கு பயன்படுத்தவா?",
      "discardChanges": "சேமிக்காத மாற்றங்களை நிராகரிக்கவா?"
    },
    "popover": {
      "grantTitle": "அனுமதியை வழங்கு",
      "denyTitle": "அனுமதியை மறு",
      "clearTitle": "அனுமதியை அழி",
      "grantNote": "இந்த அனுமதியை வழங்குவது மரபுரிமை மறுப்பை மேலெழுதும்.",
      "denyNote": "இந்த அனுமதியை மறுப்பது மரபுரிமை வழங்கலை மேலெழுதும்.",
      "clearNote": "அழித்தால் மரபுரிமை நடத்தைக்கு மீட்கப்படும்."
    },
    "toast": {
      "permissionGranted": "அனுமதி வழங்கப்பட்டது",
      "permissionDenied": "அனுமதி மறுக்கப்பட்டது",
      "permissionCleared": "அனுமதி அழிக்கப்பட்டது",
      "bulkApplied": "மொத்த மாற்றங்கள் பயன்படுத்தப்பட்டன",
      "saveError": "மாற்றங்களைச் சேமிக்க முடியவில்லை"
    }
  },
  "confirm": {
    "restartIntegration": "\"{{name}}\" ஐ மறுதொடக்கம் செய்யவா? புதிய TLS தகவல்கள் ஏற்றப்படும்போது செயலில் உள்ள இணைப்புகள் சிறிது நேரம் துண்டிக்கப்படும்.",
    "revokeFhirEndpoint": "\"{{name}}\" ஐ ரத்து செய்யவா? இந்த எண்ட்பாயிண்ட்டுக்கான வெளிச்செல்லும் அழைப்புகள் நிறுத்தப்படும்.",
    "rotateSmartSecret": "\"{{name}}\" க்கான கிளையன்ட் சீக்ரெட்டை மாற்றவா? பழைய சீக்ரெட் உடனடியாக செயல்படுவதை நிறுத்தும்.",
    "revokeSmartApp": "\"{{name}}\" ஐ ரத்து செய்யவா? இந்த ஆப்பிலிருந்து எதிர்கால டோக்கன் கோரிக்கைகள் தோல்வியடையும்.",
    "deactivateThirdPartyApp": "\"{{name}}\" ஐ செயலிழக்கச் செய்யவா?"
  },
  "toast": {
    "tierCreated": "அடுக்கு உருவாக்கப்பட்டது",
    "tierCloned": "அடுக்கு நகலெடுக்கப்பட்டது",
    "tierDeleted": "அடுக்கு நீக்கப்பட்டது",
    "tierStatusUpdated": "நிலை புதுப்பிக்கப்பட்டது",
    "tierFeaturesUpdated": "அம்சங்கள் புதுப்பிக்கப்பட்டன",
    "tierLimitsUpdated": "வரம்புகள் புதுப்பிக்கப்பட்டன",
    "tierSaveError": "அடுக்கை உருவாக்க முடியவில்லை",
    "tierValidation": "பெயர் மற்றும் குறியீடு அவசியம்",
    "licenseKeyGenerated": "உரிமச் சாவி உருவாக்கப்பட்டது",
    "licenseKeyCopied": "உரிமச் சாவி உருவாக்கப்பட்டு கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது",
    "overridesSaved": "மேலெழுதல்கள் சேமிக்கப்பட்டன",
    "pricingConfigSaved": "அமைப்பு சேமிக்கப்பட்டது",
    "pricingPriceUpdated": "விலை புதுப்பிக்கப்பட்டது",
    "pricingRuleCreated": "விலை விதி உருவாக்கப்பட்டது",
    "addonUpdated": "கூடுதல் தொகுதி புதுப்பிக்கப்பட்டது",
    "invalidNumber": "சரியான எண்ணை உள்ளிடவும்",
    "csvExported": "{{filename}} ஏற்றுமதி செய்யப்பட்டது",
    "integrationUpdated": "ஒருங்கிணைப்பு புதுப்பிக்கப்பட்டது",
    "integrationAdded": "ஒருங்கிணைப்பு சேர்க்கப்பட்டது",
    "integrationInvalidConfig": "தவறான கட்டமைப்பு — ஹோஸ்ட்/போர்ட் மற்றும் TLS புலங்களைச் சரிபார்க்கவும்",
    "integrationDuplicateName": "அந்தப் பெயரில் ஒரு ஒருங்கிணைப்பு ஏற்கனவே உள்ளது",
    "integrationSaveFailed": "ஒருங்கிணைப்பைச் சேமிக்க முடியவில்லை",
    "smartAppRegistered": "SMART செயலி பதிவு செய்யப்பட்டது",
    "smartAppRegisterFailed": "SMART செயலியைப் பதிவு செய்ய முடியவில்லை",
    "smartAppUpdated": "SMART செயலி புதுப்பிக்கப்பட்டது",
    "smartAppUpdateFailed": "SMART செயலியைப் புதுப்பிக்க முடியவில்லை",
    "fhirEndpointUpdated": "எண்ட்பாயிண்ட் புதுப்பிக்கப்பட்டது",
    "fhirEndpointRegistered": "எண்ட்பாயிண்ட் பதிவு செய்யப்பட்டது",
    "fhirEndpointInvalidConfig": "தவறான அமைப்பு — base URL மற்றும் auth புலங்களைச் சரிபார்க்கவும்",
    "fhirEndpointDuplicateName": "அந்தப் பெயரில் ஒரு எண்ட்பாயிண்ட் ஏற்கனவே உள்ளது",
    "fhirEndpointSaveFailed": "எண்ட்பாயிண்டைச் சேமிக்க முடியவில்லை",
    "clientIdCopied": "Client ID நகலெடுக்கப்பட்டது",
    "clientSecretCopied": "Client secret நகலெடுக்கப்பட்டது",
    "statusRefreshed": "நிலை புதுப்பிக்கப்பட்டது",
    "connTestOk": "இணைப்புச் சோதனை வெற்றியடைந்தது",
    "connTestFailed": "இணைப்புச் சோதனை தோல்வியடைந்தது - எண்ட்பாயிண்ட் அமைப்பைச் சரிபார்க்கவும்",
    "serverRestarted": "சர்வர் மறுதொடக்கம் செய்யப்பட்டது — புதிய TLS பொருள் நடைமுறையில்",
    "clientReconnected": "கிளையன்ட் மீண்டும் இணைக்கப்பட்டது — புதிய TLS பொருள் நடைமுறையில்",
    "notRunning": "இயங்கவில்லை — அமைப்பைப் பயன்படுத்த சர்வர்/கிளையன்ட்டைத் தொடங்கவும்",
    "restartFailed": "ஒருங்கிணைப்பை மறுதொடக்கம் செய்வதில் தோல்வி",
    "metadataOk": "/metadata சரி{{detail}}",
    "metadataFailed": "/metadata தோல்வி: {{error}}",
    "metadataProbeFailed": "/metadata சோதிக்க முடியவில்லை",
    "metadataUnknownError": "தெரியவில்லை",
    "fhirRevoked": "FHIR எண்ட்பாயிண்ட் ரத்து செய்யப்பட்டது",
    "fhirRevokeFailed": "எண்ட்பாயிண்ட்டை ரத்து செய்ய முடியவில்லை",
    "smartRevoked": "SMART செயலி ரத்து செய்யப்பட்டது",
    "smartRevokeFailed": "SMART செயலியை ரத்து செய்ய முடியவில்லை",
    "secretRotated": "கிளையன்ட் ரகசியம் சுழற்றப்பட்டது",
    "rotateSecretFailed": "ரகசியத்தைச் சுழற்ற முடியவில்லை",
    "messageRequeued": "மீண்டும் முயற்சிக்க செய்தி மீண்டும் வரிசைப்படுத்தப்பட்டது",
    "messageRetryFailed": "மீண்டும் முயற்சி தோல்வியடைந்தது",
    "messageSkipped": "செய்தி தவிர்க்கப்பட்டது — வரிசை தொடரும்",
    "messageSkipFailed": "தவிர்த்தல் தோல்வியடைந்தது",
    "messageAbandoned": "செய்தி கைவிடப்பட்டது",
    "messageAbandonFailed": "கைவிடுதல் தோல்வியடைந்தது",
    "messageResent": "செய்தி புதியதாக மீண்டும் அனுப்பப்பட்டது",
    "messageResendFailed": "மீண்டும் அனுப்புதல் தோல்வியடைந்தது",
    "reasonRequired": "காரணம் தேவை",
    "copiedToClipboard": "கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது",
    "thirdPartyAppCreated": "மூன்றாம் தரப்பு பயன்பாடு வெற்றிகரமாக உருவாக்கப்பட்டது",
    "thirdPartyAppUpdated": "மூன்றாம் தரப்பு பயன்பாடு வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "thirdPartyAppDeactivated": "மூன்றாம் தரப்பு பயன்பாடு செயலிழக்கச் செய்யப்பட்டது",
    "thirdPartyAppLaunchUrl": "தொடக்க URL உருவாக்கப்பட்டது: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "மருத்துவ நிலையத்தைச் சேர்க்கவும்",
      "editTitle": "மருத்துவ நிலையத்தைத் திருத்தவும்",
      "fields": {
        "name": "பெயர்",
        "code": "குறியீடு",
        "type": "வகை",
        "address": "முகவரி",
        "city": "நகரம்",
        "stateProvince": "மாநிலம்/மாகாணம்",
        "country": "நாடு",
        "phone": "தொலைபேசி",
        "timeZone": "நேர மண்டலம்",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "எடுத்துக்காட்டு: Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "IANA நேர மண்டலப் பெயர் (எடுத்துக்காட்டு: Asia/Singapore). நோயாளி எண்ணிக்கை, MAR மற்றும் அறிக்கைகளில் மருத்துவ நிலையத்தின் உள்ளூர் தேதிகளுக்குப் பயன்படுகிறது."
      },
      "options": {
        "otherIana": "மற்றவை (IANA)…",
        "useCuratedList": "பரிந்துரைக்கப்பட்ட பட்டியலைப் பயன்படுத்தவும்"
      },
      "errors": {
        "nameMin": "மருத்துவ நிலையப் பெயர் குறைந்தது {{min}} எழுத்துகள் கொண்டிருக்க வேண்டும்",
        "codeFormat": "குறியீட்டில் பெரிய எழுத்துகள் மற்றும் எண்கள் மட்டுமே இருக்க வேண்டும்",
        "typeRequired": "மருத்துவ நிலைய வகை தேவை",
        "countryRequired": "நாடு தேவை",
        "timeZoneRequired": "நேர மண்டலம் தேவை",
        "timeZoneInvalidIana": "சேவையகம் இந்த நேர மண்டலத்தை நிராகரித்தது. செல்லுபடியாகும் IANA பெயரைப் பயன்படுத்தவும் (எடுத்துக்காட்டு: Asia/Singapore).",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "உருவாக்கவும்",
        "update": "புதுப்பிக்கவும்"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "மருத்துவ நிலையம் வெற்றிகரமாக உருவாக்கப்பட்டது",
        "updatedSuccess": "மருத்துவ நிலையம் வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது",
        "saveError": "மருத்துவ நிலையத்தைச் சேமிக்க இயலவில்லை",
        "invalidTimeZone": "கோரிக்கை செல்லுபடியாகவில்லை — நேர மண்டலம் செல்லுபடியாகும் IANA பெயராக இருக்கிறதா எனச் சரிபார்க்கவும் (எடுத்துக்காட்டு: Asia/Singapore)."
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "வசதி மேலாண்மை",
      "subtitle": "வசதிகள், துறைகள், மேலும் (இந்த மரத்தின் வழியாக) உடல்பூர்வ இட படிநிலையின் பார்வை. முழுமையான இட மரத்திற்கு (கட்டிடம் → தளம் → பிரிவு → அறை → படுக்கை), <locationsLink>இடங்கள்</locationsLink> பார்க்கவும்.",
      "columns": {
        "name": "பெயர்",
        "code": "குறியீடு",
        "type": "வகை",
        "address": "முகவரி",
        "phone": "தொலைபேசி",
        "depts": "துறைகள்",
        "status": "நிலை",
        "actions": "செயல்கள்"
      },
      "filter": {
        "search": "வசதிகளைத் தேடவும்..."
      },
      "actions": {
        "new": "வசதியைச் சேர்",
        "editTitle": "திருத்து"
      },
      "expand": {
        "expand": "வசதியை விரிவாக்கு",
        "collapse": "வசதியை மடக்கு"
      },
      "empty": {
        "noMatch": "அந்தத் தேடலுக்குப் பொருந்தும் வசதிகள் இல்லை.",
        "none": "இன்னும் வசதிகள் இல்லை — தொடங்க வசதியைச் சேர் என்பதைக் கிளிக் செய்யவும்."
      },
      "departments": {
        "title": "துறைகள்",
        "add": "துறையைச் சேர்",
        "empty": "துறைகள் எதுவும் கட்டமைக்கப்படவில்லை",
        "locationsCount": "{{count}} இடங்கள்",
        "editTitle": "துறையைத் திருத்து"
      },
      "locations": {
        "title": "இடங்கள்",
        "add": "சேர்",
        "empty": "இந்தத் துறையில் இடங்கள் இல்லை. இட மரம் (கட்டிடம் → தளம் → பிரிவு → படுக்கை) <locationsLink>இடங்கள்</locationsLink> பகுதியில் நிர்வகிக்கப்படுகிறது."
      }
    },
    "type": {
      "generalHospital": "பொது மருத்துவமனை",
      "teachingHospital": "கற்பித்தல் மருத்துவமனை",
      "specialtyHospital": "சிறப்பு மருத்துவமனை",
      "communityHospital": "சமூக மருத்துவமனை",
      "clinic": "மருத்துவகம்"
    },
    "status": {
      "active": "செயலில்",
      "inactive": "செயலற்றது"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "சுகாதார அமைப்பை சேர்க்கவும்",
      "editTitle": "சுகாதார அமைப்பை திருத்தவும்",
      "subtitle": "நிறுவன கட்டமைப்பின் உச்ச நிலை. ஒன்று அல்லது அதற்கு மேற்பட்ட மருத்துவ வசதிகளின் தாய் அமைப்பு.",
      "sections": {
        "identity": "அடையாள விவரம்",
        "primaryContact": "முதன்மை தொடர்பு",
        "address": "முகவரி"
      },
      "fields": {
        "code": "குறியீடு",
        "name": "பெயர்",
        "taxId": "வரி அடையாள எண்",
        "contactName": "பெயர்",
        "contactEmail": "மின்னஞ்சல்",
        "contactPhone": "தொலைபேசி",
        "addressLine1": "முகவரி வரிசை 1",
        "addressLine2": "முகவரி வரிசை 2",
        "city": "நகரம்",
        "stateProvince": "மாநிலம்/மாகாணம்",
        "postalCode": "அஞ்சல் குறியீடு",
        "country": "நாடு",
        "active": "செயலில் — செயலிழக்கச் செய்ய தேர்வுநீக்கவும்."
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "உருவாக்கப்பட்ட பிறகு குறியீட்டை மாற்ற முடியாது."
      },
      "errors": {
        "codeRequired": "குறியீடு தேவை",
        "nameRequired": "பெயர் தேவை"
      },
      "submit": {
        "create": "சுகாதார அமைப்பை உருவாக்கு",
        "update": "மாற்றங்களை சேமி"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "சுகாதார அமைப்பு உருவாக்கப்பட்டது",
        "updatedSuccess": "சுகாதார அமைப்பு புதுப்பிக்கப்பட்டது",
        "saveError": "சுகாதார அமைப்பை சேமிக்க முடியவில்லை",
        "codeConflict": "இந்த அமைப்பு குறியீடு ஏற்கனவே உள்ளது",
        "invalidData": "சுகாதார அமைப்பு தரவு தவறானது"
      }
    },
    "list": {
      "title": "சுகாதார அமைப்புகள்",
      "subtitle": "நிறுவன மரத்தின் உச்சம் — ஒன்று அல்லது அதற்கு மேற்பட்ட வசதிகளை சொந்தமாகக் கொண்டுள்ள தொழில்நிறுவன / சுகாதார-அமைப்பு பெற்றோர் நிறுவனங்கள். ஆரம்ப அமைப்பிற்குப் பிறகு அரிதாக மாற்றப்படுகின்றன.",
      "columns": {
        "name": "பெயர்",
        "code": "குறியீடு",
        "contact": "தொடர்பு",
        "location": "இடம்",
        "facilities": "வசதிகள்",
        "status": "நிலை",
        "actions": "செயல்கள்"
      },
      "filter": {
        "search": "பெயர் அல்லது குறியீடு மூலம் தேடவும்..."
      },
      "actions": {
        "new": "சுகாதார அமைப்பைச் சேர்",
        "editTitle": "திருத்து"
      },
      "status": {
        "active": "செயலில்",
        "inactive": "செயலற்றது"
      },
      "empty": {
        "noMatch": "அந்தத் தேடலுக்குப் பொருந்தும் சுகாதார அமைப்புகள் இல்லை.",
        "none": "இன்னும் சுகாதார அமைப்புகள் இல்லை — தொடங்க சுகாதார அமைப்பைச் சேர் என்பதைக் கிளிக் செய்யவும்."
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "இடத்தைச் சேர்க்கவும்",
      "editTitle": "இடத்தைத் திருத்தவும்",
      "subtitle": "பௌதீக இடம் — கட்டிடம், தளம், அலகு, அறை அல்லது படுக்கை. FHIR R4 Location இணக்கமானது. படிநிலை மரத்தை உருவாக்க தாய் இடத்தின் வழியாக உள்ளமைக்கவும்.",
      "sections": {
        "hierarchy": "படிநிலை",
        "identity": "அடையாளம்",
        "classification": "வகைப்பாடு",
        "physicalAttributes": "பேரியல் பண்புகள்"
      },
      "fields": {
        "facility": "வசதி",
        "parentLocation": "தாய் இடம்",
        "department": "துறை (விருப்பம்)",
        "code": "குறியீடு",
        "abbreviation": "சுருக்கம்",
        "name": "பெயர்",
        "physicalType": "பௌதீக வகை (FHIR)",
        "clinicalType": "மருத்துவ வகை",
        "status": "நிலை (FHIR)",
        "operationalStatus": "செயல்பாட்டு நிலை (HL7 0116)",
        "building": "கட்டடம்",
        "floor": "தரை",
        "wing": "பிரிவு",
        "roomNumber": "அறை எண்",
        "bedIdentifier": "பட்டை அடையாளம்",
        "capacity": "கொள்ளளவு",
        "active": "செயலில் (பழைய கொடி)"
      },
      "placeholders": {
        "facility": "வசதியைத் தேர்ந்தெடுக்கவும்…",
        "parentNone": "இல்லை (மேல் நிலை)",
        "departmentNone": "இல்லை",
        "code": "4W-12-A",
        "name": "4W-12 படுக்கை A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "FHIR LocationPhysicalType மதிப்புத் தொகுப்பு.",
        "clinicalType": "பழையது; service_type வந்ததும் நீக்கப்படும்."
      },
      "physicalAttributes": {
        "show": "காட்டு ▾",
        "hide": "மறை ▴"
      },
      "errors": {
        "facilityRequired": "வசதி தேவை",
        "codeRequired": "குறியீடு தேவை",
        "nameRequired": "பெயர் தேவை"
      },
      "submit": {
        "create": "இடத்தை உருவாக்கு",
        "update": "மாற்றங்களை சேமி"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "இடம் உருவாக்கப்பட்டது",
        "updatedSuccess": "இடம் புதுப்பிக்கப்பட்டது",
        "saveError": "இடத்தை சேமிக்க முடியவில்லை",
        "codeConflict": "இந்த இட குறியீடு ஏற்கனவே உள்ளது",
        "invalidData": "இட தரவு தவறானது"
      }
    },
    "list": {
      "title": "இட படிநிலை",
      "subtitle": "இயற்பியல் மரம்: கட்டிடம் → தளம் → பிரிவு → அறை → படுக்கை. FHIR LocationPhysicalType உடன் இணைந்தது. ஆக்கிரமிப்பை சுழற்ற படுக்கை நிலை குறியீட்டை கிளிக் செய்யவும். வசதிகள் மற்றும் துறைகள் <facilitiesLink>வசதிகள்</facilitiesLink> இல் நிர்வகிக்கப்படுகின்றன.",
      "filter": {
        "search": "பெயர் அல்லது குறியீட்டால் தேடு...",
        "allFacilities": "அனைத்து வசதிகள்"
      },
      "actions": {
        "new": "இடத்தைச் சேர்",
        "addChildTitle": "துணை இடத்தைச் சேர்",
        "editTitle": "திருத்து"
      },
      "expand": {
        "expand": "இடத்தை விரிவாக்கு",
        "collapse": "இடத்தைச் சுருக்கு"
      },
      "bed": {
        "toggleTitle": "{{next}} ஆக மாற்ற கிளிக் செய்யவும்"
      },
      "empty": {
        "noMatch": "அந்தத் தேடலுடன் பொருந்தும் இடம் எதுவுமில்லை.",
        "none": "இந்த வசதியில் இன்னும் இடங்கள் இல்லை."
      },
      "toast": {
        "bedStatusUpdated": "படுக்கை நிலை புதுப்பிக்கப்பட்டது",
        "bedStatusError": "படுக்கை நிலையைப் புதுப்பிக்க முடியவில்லை"
      }
    },
    "type": {
      "si": "தளம்",
      "bu": "கட்டிடம்",
      "wi": "பிரிவு",
      "wa": "வார்டு",
      "lvl": "மாடி",
      "co": "நடைபாதை",
      "ro": "அறை",
      "bd": "படுக்கை",
      "ve": "மெய்நிகர்",
      "ho": "இல்லம்",
      "ca": "அலமாரி",
      "rd": "சாலை",
      "area": "பகுதி",
      "jdn": "அதிகார வரம்பு"
    },
    "clinicalType": {
      "examRoom": "பரிசோதனை அறை",
      "inpatientBed": "உள்நோயாளர் படுக்கை",
      "procedureRoom": "செயல்முறை அறை",
      "icu": "ICU",
      "ed": "அவசர பிரிவு",
      "or": "அறுவை அறை",
      "virtual": "மெய்நிகர்"
    },
    "status": {
      "active": "செயலில்",
      "suspended": "இடைநிறுத்தப்பட்டது",
      "inactive": "செயலற்ற",
      "op": {
        "O": "ஆக்கிரமிக்கப்பட்டது",
        "U": "காலியாக",
        "H": "துப்புரவு",
        "K": "மாசுபட்டது",
        "I": "தனிமைப்படுத்தப்பட்டது",
        "C": "மூடப்பட்டது"
      }
    },
    "capability": {
      "isolation": "தனிமைப்படுத்தும் திறன்",
      "negativePressure": "எதிர் அழுத்தம்",
      "bariatric": "புரடியாட்ரிக் திறன்",
      "telemetry": "தொலைமாபினி திறன்",
      "icu": "ICU நிலை"
    }
  },
  "department": {
    "form": {
      "addTitle": "துறையை சேர்க்கவும்",
      "editTitle": "துறையைத் திருத்தவும்",
      "subtitle": "மருத்துவ நிலையத்தின் உள்ளே உள்ள அமைப்புப் பிரிவு. பெற்றோர் துறை வழியாக உள்ளிணைக்கலாம் (எ.கா., இதயவியல் → EP ஆய்வகம்).",
      "sections": {
        "department": "துறை"
      },
      "fields": {
        "facility": "மருத்துவ நிலையம்",
        "code": "குறியீடு",
        "abbreviation": "சுருக்கம்",
        "name": "பெயர்",
        "type": "வகை",
        "parentDepartment": "பெற்றோர் துறை",
        "costCenterCode": "செலவு மைய குறியீடு",
        "revenueDepartmentCode": "வருவாய்த் துறை குறியீடு",
        "active": "செயலில் — செயலிழக்க தேர்வை நீக்கவும்."
      },
      "placeholders": {
        "facility": "மருத்துவ நிலையத்தைத் தேர்ந்தெடுக்கவும்…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "இதயவியல்",
        "parentNone": "ஏதுமில்லை (மேல்நிலை)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "மருத்துவ நிலையம் தேவை",
        "codeRequired": "குறியீடு தேவை",
        "nameRequired": "பெயர் தேவை"
      },
      "submit": {
        "create": "துறையை உருவாக்கவும்",
        "update": "மாற்றங்களைச் சேமிக்கவும்"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "துறை வெற்றிகரமாக உருவாக்கப்பட்டது",
        "updatedSuccess": "துறை வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது",
        "saveError": "துறையைச் சேமிக்க இயலவில்லை",
        "codeConflict": "துறை குறியீடு ஏற்கனவே உள்ளது",
        "invalidData": "துறை தரவு தவறானது"
      }
    },
    "serviceType": {
      "clinical": "மருத்துவ",
      "administrative": "நிர்வாக",
      "support": "ஆதரவு"
    },
    "status": {
      "active": "செயலில்",
      "inactive": "செயலற்ற"
    }
  },
  "provider": {
    "form": {
      "addTitle": "மருத்துவரைச் சேர்",
      "editTitle": "மருத்துவரைத் திருத்து",
      "fields": {
        "fullName": "முழுப் பெயர்",
        "npi": "NPI",
        "providerType": "வழங்குநர் வகை",
        "credentials": "தகுதிகள்",
        "specialty": "சிறப்புத்துறை",
        "email": "மின்னஞ்சல்",
        "phone": "தொலைபேசி",
        "facilityAssignments": "வசதி நியமனங்கள்",
        "status": "நிலை",
        "primaryFacility": "முதன்மை நிறுவனம்",
        "loginAccount": "உள்நுழைவு கணக்கு"
      },
      "placeholders": {
        "specialty": "சிறப்புத்துறையைத் தேர்ந்தெடு…",
        "credentials": "எ.கா. MD, FACC",
        "providerType": "வழங்குநர் வகையைத் தேர்ந்தெடுக்கவும்",
        "noLoginAccount": "உள்நுழைவு கணக்கு இல்லை"
      },
      "submit": {
        "create": "உருவாக்கு",
        "update": "புதுப்பி"
      },
      "cancel": "ரத்து",
      "toast": {
        "createdSuccess": "மருத்துவர் சேர்க்கப்பட்டார்",
        "updatedSuccess": "மருத்துவர் புதுப்பிக்கப்பட்டார்",
        "saveError": "மருத்துவரைச் சேமிக்க முடியவில்லை"
      },
      "hints": {
        "loginAccount": "இந்த மருத்துவப் பணியாளரை அவர்களின் உள்நுழைவு கணக்குடன் இணைக்கிறது. இணைக்கவில்லை எனில், இணை கையொப்பம், மருந்தாளர் சரிபார்ப்பு மற்றும் அவசர முடிவு ஒப்புகை அனைத்தும் மறுக்கப்படும்."
      }
    },
    "list": {
      "title": "வழங்குநர் மேலாண்மை",
      "subtitle": "வழங்குநர்கள், சான்றுகள் மற்றும் வசதி நியமனங்களை நிர்வகிக்கவும்",
      "columns": {
        "name": "பெயர்",
        "npi": "NPI",
        "specialty": "சிறப்புத்துறை",
        "credentials": "சான்றுகள்",
        "facilities": "வசதிகள்",
        "status": "நிலை",
        "actions": "செயல்கள்"
      },
      "filter": {
        "search": "பெயர், NPI, சிறப்புத்துறை வழியாக தேடுக...",
        "allSpecialties": "அனைத்து சிறப்புத்துறைகள்",
        "allFacilities": "அனைத்து வசதிகள்",
        "allStatus": "அனைத்து நிலைகள்"
      },
      "actions": {
        "new": "வழங்குநரைச் சேர்",
        "editTitle": "வழங்குநரைத் திருத்து",
        "scheduleTitle": "அட்டவணை வார்ப்புரு",
        "viewCredentials": "சான்றுகளைப் பார்"
      },
      "credentials": {
        "licenseLabel": "உரிமம்",
        "none": "கோப்பில் சான்றுகள் இல்லை"
      },
      "empty": "வழங்குநர்கள் எதுவும் காணப்படவில்லை",
      "pagination": {
        "summary": "{{total}} இல் {{from}}-{{to}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "முந்தைய பக்கம்",
        "next": "அடுத்த பக்கம்"
      },
      "toast": {
        "schedulePlaceholder": "அட்டவணை வார்ப்புரு இணைப்பு (இடம்பிடிப்பான்)"
      },
      "noLogin": "உள்நுழைவு இல்லை",
      "noLoginHint": "இந்த வழங்குநருக்கு உள்நுழைவு கணக்கு இணைக்கப்படவில்லை, எனவே இணை கையொப்பம், சரிபார்ப்பு அல்லது ஒப்புகை செய்ய முடியாது."
    },
    "specialty": {
      "internalMedicine": "உள் மருத்துவம்",
      "cardiology": "இதயவியல்",
      "emergencyMedicine": "அவசர மருத்துவம்",
      "pediatrics": "குழந்தை மருத்துவம்",
      "pathology": "நோய்க்குறியியல்",
      "obstetricsGynecology": "மகப்பேறு மற்றும் மகளிர் மருத்துவம்",
      "surgery": "அறுவை சிகிச்சை",
      "orthopedics": "எலும்பியல்",
      "neurology": "நரம்பியல்",
      "psychiatry": "மனநோய் மருத்துவம்",
      "radiology": "கதிரியக்கவியல்",
      "anesthesiology": "மயக்க மருத்துவம்",
      "oncology": "புற்றுநோயியல்",
      "dermatology": "தோல் மருத்துவம்",
      "ophthalmology": "கண் மருத்துவம்"
    },
    "status": {
      "active": "செயலில்",
      "inactive": "செயலற்ற",
      "onLeave": "விடுப்பில்"
    },
    "providerType": {
      "physician": "மருத்துவர்",
      "nurse": "செவிலியர்",
      "nursePractitioner": "நர்ஸ் பிராக்டிஷனர்",
      "physicianAssistant": "மருத்துவ உதவியாளர்",
      "pharmacist": "மருந்தாளர்",
      "therapist": "சிகிச்சையாளர்",
      "technician": "தொழில்நுட்பர்",
      "other": "மற்றவை",
      "midwife": "மகப்பேறு செவிலியர்",
      "dentist": "பல் மருத்துவர்",
      "pharmacyTechnician": "மருந்தக உதவியாளர்",
      "careAssistant": "செவிலிய உதவியாளர்",
      "dietitian": "ஊட்டச்சத்து நிபுணர்",
      "socialWorker": "சமூக சேவையாளர்",
      "traditionalMedicine": "பாரம்பரிய மருத்துவர்"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "சேவை வரிசையைச் சேர்",
      "editTitle": "சேவை வரிசையைத் திருத்து",
      "subtitle": "குறிப்பிட்ட மருத்துவ சேவைகளை உள்ளடக்கிய உயர்-நிலை மருத்துவ குழுமம் (இருதய-இரத்தக் குழாய், புற்றுநோயியல்).",
      "sections": {
        "serviceLine": "சேவை வரிசை"
      },
      "fields": {
        "healthSystem": "சுகாதார அமைப்பு",
        "code": "குறியீடு",
        "name": "பெயர்",
        "description": "விளக்கம்",
        "active": "செயலில் — மென்-முடக்க தேர்வை நீக்கவும்."
      },
      "placeholders": {
        "healthSystem": "சுகாதார அமைப்பைத் தேர்ந்தெடு…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "சுருக்க விளக்கம் — நோக்கம், நோய் கவனம், முதலியன."
      },
      "errors": {
        "healthSystemRequired": "சுகாதார அமைப்பு தேவை",
        "codeRequired": "குறியீடு தேவை",
        "nameRequired": "பெயர் தேவை"
      },
      "submit": {
        "create": "சேவை வரிசையை உருவாக்கு",
        "update": "மாற்றங்களைச் சேமி"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "சேவை வரிசை உருவாக்கப்பட்டது",
        "updatedSuccess": "சேவை வரிசை புதுப்பிக்கப்பட்டது",
        "saveError": "சேவை வரிசையைச் சேமிக்க முடியவில்லை",
        "codeConflict": "சேவை வரிசை குறியீடு ஏற்கனவே உள்ளது",
        "invalidData": "தவறான சேவை வரிசை தரவு"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "மருத்துவ சேவையைச் சேர்",
      "editTitle": "மருத்துவ சேவையைத் திருத்து",
      "subtitle": "குறிப்பிட்ட மருத்துவ சேவை (இருதயவியல், EP ஆய்வகம்). விருப்பப்படி சேவை வரிசையின் கீழ் தொகுக்கப்பட்டு, கட்டண நிர்வாகம் + அடைவு வெளியீட்டிற்கான NUCC சிறப்பு குறியீட்டுடன் குறிக்கப்படலாம்.",
      "sections": {
        "clinicalService": "மருத்துவ சேவை",
        "specialtyBilling": "சிறப்பு + கட்டண நிர்வாகம்"
      },
      "fields": {
        "code": "குறியீடு",
        "name": "பெயர்",
        "serviceLine": "சேவை வரிசை",
        "description": "விளக்கம்",
        "specialtyCode": "NUCC சிறப்பு குறியீடு",
        "specialtyDescription": "சிறப்பு விளக்கம்",
        "revenueDepartmentCode": "வருவாய் துறை குறியீடு",
        "active": "செயலில்"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— எதுவுமில்லை —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "NUCC வகைப்பாடு — வழங்குநர் அடைவு + உரிமக் கோரிக்கை வழங்கலை இயக்குகிறது."
      },
      "errors": {
        "codeRequired": "குறியீடு தேவை",
        "nameRequired": "பெயர் தேவை"
      },
      "submit": {
        "create": "மருத்துவ சேவையை உருவாக்கு",
        "update": "மாற்றங்களைச் சேமி"
      },
      "cancel": "ரத்து செய்",
      "toast": {
        "createdSuccess": "மருத்துவ சேவை உருவாக்கப்பட்டது",
        "updatedSuccess": "மருத்துவ சேவை புதுப்பிக்கப்பட்டது",
        "saveError": "மருத்துவ சேவையைச் சேமிக்க முடியவில்லை",
        "codeConflict": "மருத்துவ சேவை குறியீடு ஏற்கனவே உள்ளது",
        "invalidData": "தவறான மருத்துவ சேவை தரவு"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "சேவை ↔ இடம் ஒதுக்கீடு",
    "subtitle": "எந்த மருத்துவ சேவைகள் எந்த இயற்பியல் இடங்களில் இயங்குகின்றன, விருப்பத் தேர்வு நாள்/நேர சாளரங்கள் மற்றும் கொள்ளளவுடன். கிடைக்கும் இடங்களை உருவாக்க கால அட்டவணை இவற்றைப் படிக்கிறது. மென்-நீக்கம் மட்டுமே — ஒதுக்கீட்டை முடித்தாலும் அறிக்கைகளுக்காக வரலாறு பாதுகாக்கப்படும்.",
    "header": {
      "newAssignment": "புதிய ஒதுக்கீடு",
      "toggleCancel": "ரத்து செய்"
    },
    "form": {
      "title": "புதிய ஒதுக்கீடு",
      "fields": {
        "service": "மருத்துவ சேவை",
        "location": "இடம்",
        "dayOfWeekPattern": "வார-நாள் முறை",
        "startTime": "தொடக்க நேரம்",
        "endTime": "முடிவு நேரம்",
        "capacity": "கொள்ளளவு %",
        "notes": "குறிப்புகள்",
        "isPrimary": "இந்தச் சேவைக்கான முதன்மை இடம்"
      },
      "placeholders": {
        "service": "சேவையைத் தேர்ந்தெடு…",
        "location": "இடத்தைத் தேர்ந்தெடு…",
        "dayOfWeekPattern": "1,3,5 (திங்/புத/வெள்)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "காற்புள்ளியால் பிரிக்கப்பட்ட ISO வார நாட்கள்; வெறுமை = தினமும்."
      },
      "errors": {
        "serviceLocationRequired": "சேவை மற்றும் இடம் தேவை"
      },
      "create": "உருவாக்கு",
      "cancel": "ரத்து செய்"
    },
    "filter": {
      "allFacilities": "அனைத்து வசதிகள்",
      "allServices": "அனைத்து சேவைகள்",
      "allLocations": "அனைத்து இடங்கள்",
      "allStatuses": "அனைத்து நிலைகள்",
      "searchService": "சேவைகளைத் தேடு…",
      "searchLocation": "இடங்களைத் தேடு…",
      "facility": "வசதி",
      "serviceLine": "சேவை வரிசை"
    },
    "columns": {
      "service": "சேவை",
      "location": "இடம்",
      "facility": "வசதி",
      "when": "எப்போது",
      "capacity": "கொள்ளளவு",
      "effective": "அமலில்",
      "status": "நிலை",
      "actions": "செயல்கள்"
    },
    "status": {
      "active": "செயலில்",
      "planned": "திட்டமிடப்பட்டது",
      "suspended": "இடைநிறுத்தப்பட்டது",
      "ended": "முடிந்தது"
    },
    "dow": {
      "everyDay": "தினமும்",
      "monFri": "திங்–வெள்",
      "short": {
        "1": "திங்",
        "2": "செவ்",
        "3": "புத",
        "4": "வியா",
        "5": "வெள்",
        "6": "சனி",
        "7": "ஞாயி"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "முதன்மை இடம்",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "முதன்மையாக அமை",
      "unsetPrimary": "முதன்மையை நீக்கு",
      "endAssignment": "ஒதுக்கீட்டை முடி"
    },
    "bulkEdit": {
      "title": "மொத்தத் திருத்தம்",
      "applyTo": "தேர்ந்தெடுத்தவற்றுக்குப் பயன்படுத்து",
      "selectedServices": "{{count}} சேவை(கள்)",
      "selectedLocations": "{{count}} இடம்(ங்கள்)",
      "save": "மாற்றங்களைச் சேமி",
      "cancel": "ரத்து செய்"
    },
    "confirm": {
      "endTitle": "ஒதுக்கீட்டை முடிக்கவா?",
      "endDescription": "{{service}} → {{location}}. முடித்தாலும் வரலாறு பாதுகாக்கப்படும், ஆனால் இந்த இணை செயலில் உள்ள கால அட்டவணையிலிருந்து நீக்கப்படும்.",
      "endConfirm": "ஒதுக்கீட்டை முடி",
      "removeService": "{{location}} இலிருந்து {{service}} ஐ அகற்றவா?",
      "makePrimary": "{{location}} ஐ {{service}} இன் முதன்மை இடமாக அமைக்கவா?"
    },
    "toast": {
      "created": "ஒதுக்கீடு உருவாக்கப்பட்டது",
      "createError": "ஒதுக்கீட்டை உருவாக்க முடியவில்லை",
      "ended": "ஒதுக்கீடு முடிக்கப்பட்டது",
      "endError": "ஒதுக்கீட்டை முடிக்க முடியவில்லை",
      "primaryError": "முதன்மையை மாற்ற முடியவில்லை",
      "updated": "ஒதுக்கீடு புதுப்பிக்கப்பட்டது"
    },
    "empty": "இந்த வடிப்பான்களுக்குப் பொருந்தும் ஒதுக்கீடு இல்லை. சேர்க்க புதிய ஒதுக்கீடு ஐ கிளிக் செய்க."
  },
  "integration": {
    "list": {
      "title": "ஒருங்கிணைப்பு மேலாண்மை",
      "subtitle": "HL7, FHIR மற்றும் மூன்றாம் தரப்பு அமைப்பு ஒருங்கிணைப்புகள்",
      "refresh": "புதுப்பி",
      "addEndpoint": "எண்ட்பாயிண்ட் சேர்",
      "searchPlaceholder": "ஒருங்கிணைப்புகளைத் தேடு…",
      "tabs": {
        "endpoints": "எண்ட்பாயிண்ட்கள்",
        "messageLog": "செய்தி பதிவு",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "மொத்த எண்ட்பாயிண்ட்கள்",
        "connected": "இணைக்கப்பட்டது",
        "errors": "பிழைகள்",
        "totalMessages": "மொத்த செய்திகள்"
      }
    },
    "columns": {
      "status": "நிலை",
      "name": "பெயர்",
      "type": "வகை",
      "direction": "திசை",
      "url": "URL",
      "tls": "TLS",
      "auth": "அங்கீகாரம்",
      "lastMessage": "கடைசி செய்தி",
      "messages": "செய்திகள்",
      "errors": "பிழைகள்",
      "backlog": "நிலுவை",
      "health": "ஆரோக்கியம்",
      "actions": "செயல்கள்",
      "backlogTitle": "நிலுவையிலுள்ள வெளிச்செல் செய்திகள் + மிகப் பழைய நிலுவை வயது",
      "healthTitle": "ஆரோக்கிய நிலை — தோல்வியுற்ற செய்தியால் வரிசை தடைபட்டால் சிவப்பு"
    },
    "badge": {
      "tlsCerts": "சான்றிதழ்: {{cert}}, விசை: {{key}}, CA: {{ca}}",
      "yes": "ஆம்",
      "no": "இல்லை",
      "basicTitle": "basic ({{username}})",
      "bearerStored": "Bearer டோக்கன் சேமிக்கப்பட்டது",
      "bearerNoToken": "bearer (டோக்கன் அமைக்கப்படவில்லை)",
      "mtlsCert": "mTLS கிளையன்ட் சான்றிதழ்",
      "awaitingAck": "{{n}} ACK காத்திருக்கிறது",
      "oldest": "மிகப் பழையது {{age}}",
      "never": "ஒருபோதும் இல்லை",
      "blocked": "தடைசெய்யப்பட்டது",
      "waiting": "காத்திருக்கிறது",
      "ok": "சரி",
      "blockedTitle": "தோல்வியுற்ற செய்தி இந்த ஒருங்கிணைப்பின் வரிசையைத் தடுக்கிறது. வடிகட்டிய பதிவைத் திறக்க கிளிக் செய்க.",
      "waitingTitle": "கூட்டாளரிடமிருந்து மேம்படுத்தப்பட்ட பயன்முறை செயலி ACK காத்திருக்கும் செய்திகள். வடிகட்டிய பதிவைத் திறக்க கிளிக் செய்க.",
      "okTitle": "அனைத்தும் சரி — இந்த ஒருங்கிணைப்பின் செய்தி பதிவைத் திறக்க கிளிக் செய்க.",
      "receives": "பெறுகிறது"
    },
    "action": {
      "testConnection": "இணைப்பைச் சோதி",
      "restartTls": "மறுதொடக்கம் — புதிதாக சுழற்றப்பட்ட TLS-ஐப் பயன்படுத்து",
      "investigate": "த்ரூபுட், தாமதம் மற்றும் சமீபத்திய தோல்விகள்",
      "edit": "திருத்து"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "சமீபத்திய 50 செய்திகள்",
      "columns": {
        "time": "நேரம்",
        "id": "ID",
        "direction": "திசை",
        "type": "வகை",
        "source": "மூலம்",
        "summary": "சுருக்கம்",
        "status": "நிலை"
      },
      "dir": {
        "in": "உள்",
        "out": "வெளி"
      }
    },
    "fhir": {
      "serverStatusHeader": "FHIR R4 சர்வர் நிலை",
      "serverOnline": "சர்வர் ஆன்லைனில்",
      "supportedResources": "ஆதரிக்கப்படும் வளங்கள்",
      "version": "பதிப்பு",
      "externalHeader": "வெளிப்புற FHIR எண்ட்பாயிண்ட்கள்",
      "registerEndpoint": "எண்ட்பாயிண்ட் பதிவு",
      "columns": {
        "name": "பெயர்",
        "baseUrl": "அடிப்படை URL",
        "auth": "அங்கீகாரம்",
        "status": "நிலை",
        "lastChecked": "கடைசி சரிபார்ப்பு",
        "actions": "செயல்கள்"
      },
      "emptyEndpoints": "இதுவரை வெளிப்புற FHIR எண்ட்பாயிண்ட் எதுவும் பதிவு செய்யப்படவில்லை.",
      "revoked": "ரத்து செய்யப்பட்டது",
      "statusOk": "சரி",
      "statusError": "பிழை",
      "testMetadata": "/metadata சோதி",
      "edit": "திருத்து",
      "revoke": "ரத்து செய்"
    },
    "smart": {
      "header": "பதிவு செய்யப்பட்ட SMART செயலிகள்",
      "registerApp": "செயலியைப் பதிவு செய்",
      "columns": {
        "appName": "செயலி பெயர்",
        "clientId": "Client ID",
        "scopes": "ஸ்கோப்புகள்",
        "status": "நிலை",
        "lastModified": "கடைசி மாற்றம்",
        "actions": "செயல்கள்"
      },
      "emptyApps": "இதுவரை SMART செயலி எதுவும் பதிவு செய்யப்படவில்லை.",
      "edit": "திருத்து",
      "rotateSecret": "கிளையன்ட் ரகசியத்தைச் சுழற்று",
      "revoke": "ரத்து செய்"
    },
    "secretModal": {
      "title": "இந்த client secret-ஐ இப்போதே சேமிக்கவும்",
      "body": "இந்த secret ஒரே ஒரு முறை மட்டுமே காட்டப்படும். இழந்தால், புதியதை வழங்க secret-ஐ சுழற்றவும்.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID-ஐ நகலெடு",
      "copyClientSecret": "Client Secret-ஐ நகலெடு",
      "saved": "நான் சேமித்துவிட்டேன்"
    },
    "drawer": {
      "header": "ஒருங்கிணைப்பு #{{id}}",
      "refresh": "புதுப்பி",
      "close": "மூடு",
      "queueBlocked": "வரிசை தடைபட்டது",
      "queueBlockedBody": "தோல்வியடைந்த ஒரு செய்தி இந்த ஒருங்கிணைப்பை அனுப்புவதைத் தடுக்கிறது. அதன் பின்னுள்ள செய்திகள் ஒரு இயக்குநர் நடவடிக்கை எடுக்கும் வரை காத்திருக்கும்.",
      "investigate": "ஆராய்",
      "tiles": {
        "backlog": "நிலுவை",
        "success24h": "வெற்றி 24h",
        "avgLatency24h": "சராசரி தாமதம் 24h",
        "awaitingAck": "app-ACK காத்திருப்பு"
      },
      "charts": {
        "throughput": "த்ரூபுட் (24h)",
        "throughputSub": "மணிநேர பகுதிகள். அடுக்கப்பட்டது: வெளிச்செல்லும் முடிந்தது + தோல்வி; உள்வரும் இரண்டாம் அச்சில்.",
        "successRate": "வெற்றி விகிதம் (24h)",
        "successRateSub": "ஒவ்வொரு பகுதிக்கும்: முடிந்தது / (முடிந்தது + தோல்வி). இடைவெளிகள் செயலற்ற பகுதிகள்.",
        "ackLatency": "ACK தாமதம் (24h)",
        "ackLatencySub": "அனுப்புதல் மற்றும் ACK பெறப்பட்டதற்கு இடையிலான நேரம். avg தொடர்கோடு, p95 புள்ளிக்கோடு."
      },
      "series": {
        "outCompleted": "வெளி · முடிந்தது",
        "outFailed": "வெளி · தோல்வி",
        "inReceived": "உள் · பெறப்பட்டது",
        "successPct": "வெற்றி %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "சமீபத்திய தோல்விகள்",
      "viewAll": "அனைத்தையும் காண்க →",
      "noFailures": "சமீபத்திய சாளரத்தில் தோல்வியடைந்த செய்திகள் இல்லை. 🎉"
    }
  },
  "integrationStatus": {
    "connected": "இணைக்கப்பட்டது",
    "disconnected": "துண்டிக்கப்பட்டது",
    "error": "பிழை"
  },
  "integrationDirection": {
    "server": "சர்வர்",
    "client": "கிளையன்ட்"
  },
  "messageStatus": {
    "sent": "அனுப்பப்பட்டது",
    "received": "பெறப்பட்டது",
    "error": "பிழை",
    "acknowledged": "உறுதிப்படுத்தப்பட்டது"
  },
  "smartAppStatus": {
    "active": "செயலில்",
    "revoked": "ரத்து செய்யப்பட்டது"
  },
  "interfaceMessageStatus": {
    "pending": "நிலுவையில்",
    "processing": "செயலாக்கம்",
    "completed": "முடிந்தது",
    "received": "பெறப்பட்டது",
    "processed": "செயலாக்கப்பட்டது",
    "failed": "தோல்வி",
    "error": "பிழை",
    "rejected": "நிராகரிக்கப்பட்டது",
    "deadLetter": "டெட் லெட்டர்",
    "skipped": "தவிர்க்கப்பட்டது",
    "awaitingAppAck": "ஆப் ACK க்காக காத்திருக்கிறது"
  },
  "interfaceDirection": {
    "in": "உள்வரும்",
    "out": "வெளிச்செல்லும்"
  },
  "attemptOutcome": {
    "sent": "அனுப்பப்பட்டது",
    "appNak": "ஆப் NAK",
    "timeout": "நேரம் முடிந்தது",
    "networkError": "பிணைய பிழை"
  },
  "fhirEndpoint": {
    "titleEdit": "FHIR எண்ட்பாயிண்டைத் திருத்து",
    "titleRegister": "FHIR எண்ட்பாயிண்டைப் பதிவு செய்",
    "subtitle": "கேட்வே வெளிநோக்கி தொடர்பு கொள்ளும் வெளிப்புற FHIR R4 கூட்டாளர்கள். ஒருங்கிணைப்புப் பட்டியலில் உள்ள Test Connection பொத்தான் அமைக்கப்பட்ட auth + TLS உடன் <code>/metadata</code> ஐ ஆராய்கிறது.",
    "back": "பின்செல்",
    "cancel": "ரத்து",
    "storedBlank": "சேமிக்கப்பட்டது — வைத்திருக்க காலியாக விடவும்",
    "save": {
      "changes": "மாற்றங்களைச் சேமி",
      "register": "எண்ட்பாயிண்டைப் பதிவு செய்"
    },
    "section": {
      "basics": "அடிப்படை",
      "auth": "அங்கீகாரம்",
      "tls": "TLS"
    },
    "fields": {
      "name": "பெயர்",
      "baseUrl": "Base URL",
      "description": "விளக்கம்",
      "active": "செயலில் — soft-revoke செய்ய தேர்வுநீக்கவும்.",
      "method": "முறை",
      "username": "பயனர்பெயர்",
      "password": "கடவுச்சொல்",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "https:// தேவை (வளர்ச்சிக்கு http://localhost ஏற்கப்படும்). Test போது இறுதியில் /metadata தானாகச் சேர்க்கப்படும்.",
      "oauth2": "OAuth2 டோக்கன் பெறுதல் நிர்வாகப் பக்கத்தில் இணைக்கப்பட்டுள்ளது; ரன்டைம் ஃபெட்சர் தொடர்நடவடிக்கையில் வரும். தற்போது, மதிப்புகளை நிரப்பி மீதமுள்ள அமைப்பைச் சரிபார்க்க Test ஐ இயக்கவும்.",
      "tls": "பார்ட்னரின் சர்வர் சான்றிதழைப் பின் செய்ய ரூட் CA ஐ ஒட்டவும், அல்லது mTLS க்கு client cert + key ஐ ஒட்டவும். நன்கறிந்த CA க்கு, CA மட்டும் கணினி ரூட் ஸ்டோருடன் வேலை செய்யும்."
    },
    "option": {
      "method": {
        "none": "எதுவுமில்லை",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — பெரும்பாலான பார்ட்னர்களுக்கு விருப்பம்",
      "clientCertRequired": "Client certificate (PEM) — தேவை",
      "clientCertMtls": "Client certificate (PEM) — mTLS க்கு",
      "clientKeyRequired": "Client private key (PEM) — தேவை",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "பெயர் தேவை",
      "baseUrlRequired": "Base URL தேவை",
      "baseUrlInvalid": "அடிப்படை URL செல்லுபடியாகும் http(s) URL ஆக இருக்க வேண்டும்",
      "basicUsername": "Basic auth க்கு பயனர்பெயர் தேவை",
      "basicPassword": "Basic auth க்கு கடவுச்சொல் தேவை",
      "bearerToken": "Bearer auth க்கு token தேவை",
      "clientCertKey": "Client-certificate auth க்கு cert + key தேவை"
    }
  },
  "smartApp": {
    "titleEdit": "SMART செயலியைத் திருத்து",
    "titleRegister": "SMART செயலியைப் பதிவு செய்",
    "subtitle": "SMART on FHIR கிளையன்ட் பதிவு. Client ID உங்களுக்காகத் தானாக உருவாக்கப்படும்; client secret உருவாக்கம் அல்லது சுழற்சிக்குப் பிறகு ஒரே ஒரு முறை மட்டுமே காட்டப்படும்.",
    "back": "பின்செல்",
    "cancel": "ரத்துசெய்",
    "save": "மாற்றங்களைச் சேமி",
    "register": "பதிவு செய்",
    "fields": {
      "appName": "செயலியின் பெயர்",
      "redirectUris": "திருப்பிவிடல் URI",
      "scopes": "ஸ்கோப்கள்",
      "launchUrl": "தொடக்க URL",
      "logoUrl": "லோகோ URL",
      "active": "செயலில் — இந்தச் செயலியை மென்-ரத்து செய்ய தேர்வை நீக்கவும்."
    },
    "placeholder": {
      "appName": "எனது EHR தொடக்கி"
    },
    "helper": {
      "redirectUris": "ஒரு வரிக்கு ஒரு URI. https:// தேவை (மேம்பாட்டிற்கு http://localhost-ம் ஏற்கப்படும்)."
    },
    "secretModal": {
      "title": "இந்த client secret-ஐ இப்போதே சேமிக்கவும்",
      "body": "இந்த secret ஒரே ஒரு முறை மட்டுமே காட்டப்படும். இழந்தால், புதியதை வழங்க secret-ஐ சுழற்றவும்.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID-ஐ நகலெடு",
      "copyClientSecret": "Client Secret-ஐ நகலெடு",
      "saved": "நான் சேமித்துவிட்டேன்"
    },
    "validation": {
      "nameRequired": "பெயர் தேவை",
      "redirectUriRequired": "குறைந்தது ஒரு திருப்பிவிடல் URI தேவை",
      "scopeRequired": "குறைந்தது ஒரு ஸ்கோப் தேவை"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "இடைமுக செய்தி பதிவு",
      "subtitle": "ஒவ்வொரு செயலில் உள்ள ஒருங்கிணைப்பிலும் உள்வரும் + வெளிச்செல்லும் HL7 செய்திகள்.",
      "refresh": "புதுப்பி",
      "loading": "செய்திகள் ஏற்றப்படுகின்றன…",
      "empty": "தற்போதைய வடிப்பான்களுக்கு பொருந்தும் செய்தி இல்லை.",
      "pagination": "{{total}} செய்திகள் • பக்கம் {{page}} / {{pages}}",
      "prev": "முந்தைய",
      "next": "அடுத்து",
      "archived": "(காப்பகம்)"
    },
    "relative": {
      "secondsAgo": "{{n}} வி. முன்",
      "minutesAgo": "{{n}} நி. முன்",
      "hoursAgo": "{{n}} ம. முன்"
    },
    "filter": {
      "header": "வடிப்பான்கள்",
      "direction": "திசை",
      "status": "நிலை",
      "messageType": "செய்தி வகை",
      "msh10": "MSH-10 கொண்டுள்ளது",
      "integrationId": "ஒருங்கிணைப்பு ID",
      "includeArchive": "காப்பகத்தைச் சேர்",
      "clear": "வடிப்பான்களை அழி",
      "any": "ஏதேனும்",
      "messageTypePlaceholder": "எ.கா. ADT^A01",
      "controlIdPlaceholder": "கட்டுப்பாட்டு id"
    },
    "columns": {
      "id": "ID",
      "dir": "திசை",
      "integ": "ஒருங்கி.",
      "type": "வகை",
      "msh10": "MSH-10",
      "status": "நிலை",
      "ack": "ACK",
      "attempts": "முயற்சிகள்",
      "when": "எப்போது"
    },
    "detail": {
      "eyebrow": "{{direction}} செய்தி",
      "close": "மூடு",
      "loading": "ஏற்றுகிறது…",
      "tabs": {
        "overview": "மேலோட்டம்",
        "rawHl7": "மூல HL7",
        "attempts": "முயற்சிகள்"
      },
      "operatorActions": "இயக்குநர் செயல்கள்",
      "retry": "மீண்டும் முயற்சி",
      "skip": "தவிர்",
      "abandon": "கைவிடு",
      "resendAsNew": "புதியதாக மீண்டும் அனுப்பு",
      "skipReason": "தவிர்க்கும் காரணம்",
      "abandonReason": "கைவிடும் காரணம்",
      "actionsHelper": "செயல்கள் உங்கள் பயனர் ID + காரணத்துடன் தணிக்கை செய்யப்படும். தவிர் மற்றும் கைவிடு ஆகியவற்றுக்குக் காரணம் தேவை.",
      "overview": {
        "direction": "திசை",
        "integration": "ஒருங்கிணைப்பு",
        "type": "வகை",
        "msh10": "MSH-10",
        "status": "நிலை",
        "ackCode": "ACK குறியீடு",
        "attempts": "முயற்சிகள்",
        "created": "உருவாக்கப்பட்டது",
        "ackReceived": "ACK பெறப்பட்டது",
        "nextRetry": "அடுத்த மறுமுயற்சி",
        "ackText": "ACK உரை",
        "lastError": "கடைசி பிழை",
        "sourceEventId": "மூல நிகழ்வு ID"
      },
      "rawViewer": {
        "permissionDenied": "மறைகுறியாக்கப்பட்ட மூல HL7-க்கு <code>INTERFACE_OPERATE</code> அனுமதி தேவை.",
        "notAvailable": "இந்தச் செய்திக்கு மூல பேலோடு கிடைக்கவில்லை.",
        "bytes": "{{bytes}} பைட்டுகள்",
        "copy": "நகலெடு"
      },
      "attempts": {
        "inboundInfo": "முயற்சி வரலாறு வெளிச்செல்லும் செய்திகளுக்கு மட்டுமே கண்காணிக்கப்படுகிறது. உள்வரும் செய்திகள் ஒவ்வொரு MSH-10-க்கும் ஒருமுறை செயலாக்கப்படும்; மறுபரிமாற்றங்கள் புதிய முயற்சி இல்லாமல் தற்காலிக ACK-ஐத் திருப்பும்.",
        "totalAttempts": "மொத்த முயற்சிகள்",
        "nextAt": " ({{time}}-இல் அடுத்தது)",
        "refresh": "புதுப்பி",
        "loading": "முயற்சிகள் ஏற்றப்படுகின்றன…",
        "error": "முயற்சிகளை ஏற்ற முடியவில்லை.",
        "empty": "இதுவரை முயற்சிகள் பதிவாகவில்லை. ஒவ்வொரு அனுப்புதலுக்கும் வேலையாள் ஒரு வரிசையை எழுதுகிறார்; முதல் கோரிக்கைக்குப் பிறகு இப்பட்டியல் நிரப்பப்படும்.",
        "columns": {
          "when": "எப்போது",
          "outcome": "விளைவு",
          "ack": "ACK",
          "duration": "கால அளவு",
          "detail": "விவரம்"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "மூன்றாம் தரப்பு பயன்பாடுகள்",
      "subtitle": "நோயாளர் சூழலுடன் VynaEMR இலிருந்து தொடங்கக்கூடிய வெளிப்புற பயன்பாடுகளை உள்ளமைக்கவும்",
      "addApp": "பயன்பாட்டைச் சேர்",
      "searchPlaceholder": "பெயர், குறியீடு அல்லது வகை மூலம் பயன்பாடுகளைத் தேடு...",
      "emptyTitle": "எந்த பயன்பாடும் உள்ளமைக்கப்படவில்லை",
      "emptyBody": "PACS பார்வையாளர்கள், ஆய்வக போர்ட்டல்கள் அல்லது மருந்தக அமைப்புகள் போன்ற வெளிப்புற பயன்பாடுகளைச் சேர்க்கவும்.",
      "columns": {
        "application": "பயன்பாடு",
        "category": "வகை",
        "url": "URL",
        "security": "பாதுகாப்பு",
        "display": "காட்சி",
        "status": "நிலை",
        "actions": "செயல்கள்"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "JWT கையொப்பமிடப்பட்டது",
      "hmac": "HMAC",
      "hmacSigned": "HMAC கையொப்பமிடப்பட்டது",
      "none": "எதுவுமில்லை",
      "chart": "விளக்கப்படம்",
      "sidebar": "பக்கப்பட்டை",
      "active": "செயலில்",
      "inactive": "செயலற்றது"
    },
    "action": {
      "testLaunch": "சோதனை தொடக்கம்",
      "edit": "திருத்து",
      "deactivate": "செயலிழக்கச் செய்"
    },
    "form": {
      "titleEdit": "பயன்பாட்டைத் திருத்து",
      "titleNew": "புதிய பயன்பாடு",
      "fields": {
        "appCode": "பயன்பாட்டுக் குறியீடு",
        "appName": "பயன்பாட்டுப் பெயர்",
        "category": "வகை",
        "baseUrl": "அடிப்படை URL",
        "launchMethod": "தொடக்க முறை",
        "paramMappings": "அளவுரு இணைப்புகள்",
        "enableJwt": "JWT டோக்கன் கையொப்பத்தை இயக்கு",
        "sharedSecret": "பகிரப்பட்ட ரகசியம் (JWT கையொப்ப விசை)",
        "enableHmac": "URL கையொப்பத்தை இயக்கு (HMAC)",
        "hmacKey": "HMAC விசை",
        "requiredPermission": "தேவையான அனுமதி",
        "displayOrder": "காட்சி வரிசை",
        "showInChart": "விளக்கப்படத்தில் காட்டு",
        "showInSidebar": "பக்கப்பட்டையில் காட்டு"
      },
      "placeholder": {
        "appCode": "எ.கா. pacs_viewer",
        "appName": "எ.கா. PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "URL அளவுருப் பெயர்",
        "unchanged": "(மாற்றமில்லை)",
        "sharedSecret": "பகிரப்பட்ட ரகசியத்தை உள்ளிடவும்",
        "hmacKey": "HMAC விசையை உள்ளிடவும்",
        "requiredPermission": "எ.கா. RESULT_VIEW (காலி = எந்தப் பயனரும்)"
      },
      "addParameter": "அளவுரு சேர்",
      "cancel": "ரத்து",
      "submitUpdate": "பயன்பாட்டைப் புதுப்பி",
      "submitCreate": "பயன்பாட்டை உருவாக்கு"
    },
    "paramSource": {
      "patientMrn": "நோயாளர் MRN",
      "patientName": "நோயாளர் பெயர்",
      "patientDob": "நோயாளர் DOB",
      "encounterId": "சந்திப்பு ID",
      "encounterNumber": "சந்திப்பு எண்",
      "orderNumber": "ஆணை எண்",
      "userName": "தற்போதைய பயனர் பெயர்",
      "userId": "தற்போதைய பயனர் ID",
      "timestamp": "தற்போதைய நேர முத்திரை"
    },
    "launch": "{{name}} ஐ தொடங்கு"
  },
  "integrationForm": {
    "titleEdit": "ஒருங்கிணைப்பைத் திருத்து",
    "titleAdd": "ஒருங்கிணைப்பைச் சேர்",
    "subtitle": "VynaHL7 ஆல் ஆதரிக்கப்படும் MLLP மற்றும் HL7-over-HTTP இடைமுகங்கள். சான்றிதழ் தரவு ஒருங்கிணைப்பு வரிசையில் சேமிக்கப்படுகிறது; சுழற்சிகள் சேவையகம் அல்லது கிளையன் அடுத்த முறை மறுதொடக்கம் செய்யப்படும்போது நடைமுறைக்கு வரும்.",
    "back": "பின்செல்",
    "cancel": "ரத்து",
    "saveChanges": "மாற்றங்களைச் சேமி",
    "addIntegration": "ஒருங்கிணைப்பைச் சேர்",
    "storedBlank": "சேமிக்கப்பட்டது — தக்கவைக்க வெறுமையாக விடவும்",
    "selectSibling": "— ஒரு சகோதர ஒருங்கிணைப்பைத் தேர்ந்தெடுக்கவும் —",
    "section": {
      "basics": "அடிப்படை",
      "connection": "இணைப்பு",
      "tls": "TLS / mTLS",
      "auth": "அங்கீகாரம்",
      "ackDelivery": "ஒப்புகை & வழங்கல்",
      "outboundRouting": "வெளிச்செல்லும் வழித்தடம்",
      "inboundTrust": "உள்வரும் நம்பகத்தன்மை"
    },
    "fields": {
      "name": "பெயர்",
      "type": "வகை",
      "direction": "திசை",
      "description": "விளக்கம்",
      "active": "செயலில் — இந்த இடைமுகத்தை மென்-முடக்க தேர்வை நீக்கவும்.",
      "host": "ஹோஸ்ட்",
      "port": "போர்ட்",
      "enableTls": "TLS ஐ இயக்கு — பயன்படுத்துவது",
      "serverCert": "சேவையக சான்றிதழ் (PEM)",
      "clientCert": "கிளையன் சான்றிதழ் (PEM) — mTLS க்கு விருப்பத்தேர்வு",
      "serverKey": "சேவையக தனிப்பட்ட விசை (PEM)",
      "clientKey": "கிளையன் தனிப்பட்ட விசை (PEM)",
      "serverCa": "கிளையன் CA நம்பிக்கைச் சேமிப்பு (PEM) — mTLS க்கு",
      "clientCa": "சேவையக CA நம்பிக்கைச் சேமிப்பு (PEM) — விருப்பத்தேர்வு, கணினி ரூட்டுக்குத் திரும்பும்",
      "method": "முறை",
      "username": "பயனர்பெயர்",
      "password": "கடவுச்சொல்",
      "bearerToken": "Bearer டோக்கன்",
      "inboundAck": "உள்வரும் ACK கொள்கை",
      "outboundAck": "வெளிச்செல்லும் ACK கொள்கை",
      "processingTimeout": "செயலாக்க நேரக் கெடு (மி.வி.)",
      "pendingAckTtl": "நிலுவையிலுள்ள ACK TTL (வினாடிகள்)",
      "networkRetry": "நெட்வொர்க் மறுமுயற்சி அதிகபட்சம்",
      "appNakRetry": "ஆப் NAK மறுமுயற்சி அதிகபட்சம்",
      "reverseIntegration": "தலைகீழ் சேனல் ஒருங்கிணைப்பு",
      "outboundTypes": "பெறப்படும் செய்தி வகைகள்",
      "outboundEvents": "நிகழ்வு அளவிலான சந்தாக்கள்",
      "receivingApplication": "பெறும் பயன்பாடு (MSH-5)",
      "receivingFacility": "பெறும் நிறுவனம் (MSH-6)",
      "inboundTrustProfile": "இந்தப் பங்குதாரர் செய்யலாம்"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "இந்த இடைமுகம் பற்றிய சுருக்கக் குறிப்பு — உரிமையாளர், நோக்கம், செய்தி வகைகள் போன்றவை.",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "பிணைப்பு முகவரி. அனைத்து இடைமுகங்களிலும் கேட்க 0.0.0.0 ஐப் பயன்படுத்தவும்.",
      "hostClient": "இந்தக் கிளையன் இணைக்க வேண்டிய தொலை ஹோஸ்ட்.",
      "tlsHandshake": "ஹேண்ட்ஷேக்கிற்காக.",
      "authClientCert": "கிளையன் சான்றிதழ்/விசை மேலே உள்ள TLS பிரிவிலிருந்து வரும்.",
      "authNone": "HTTP அங்கீகார தலைப்பு இணைக்கப்படவில்லை.",
      "authRs7": "{{call}} இதை ஒவ்வொரு வெளிச்செல்லும் கோரிக்கையிலும் இணைக்கிறது.",
      "ackDefaults": "நுழைவாயில் உள்வரும் HL7 செய்திகளை எவ்வாறு ACK செய்கிறது மற்றும் வெளிச்செல்லும் அனுப்புதலில் பதில் ACK ஐ எவ்வாறு விளக்குகிறது என்பதைக் கட்டுப்படுத்துகிறது. இயல்புநிலை மதிப்புகள்",
      "ackDefaultsTail": "0.19.0 க்கு முந்தைய நடத்தையுடன் பொருந்தும் — தேவைக்கேற்ப ஒவ்வொரு கூட்டாளருக்கும் மாற்றவும்.",
      "processingTimeout": "ஒத்திசை ஆப்-ACK இன்லைன் செயலாக்கத்திற்கான வரம்பு. நேரக் கெடு → AE + பின்னணி வரிசை மறுமுயற்சி.",
      "pendingAckTtl": "மேம்படுத்தப்பட்ட பயன்முறை ஆப்-ACK காத்திருப்பு, அதன் பிறகு துடைப்பான் நேரக் கெடு செய்கிறது.",
      "networkRetry": "வரிசை தடுக்கப்படுவதற்கு முன் போக்குவரத்துப் பிழைகளுக்கான மறுமுயற்சிகள்.",
      "appNakRetry": "AE/AR/CE/CR க்கான மறுமுயற்சிகள் — அதே பேலோடு மறுமுயற்சியில் அரிதாகவே வெற்றிபெறுவதால் பொதுவாக 2–3.",
      "reverse": "மேம்படுத்தப்பட்ட பயன்முறை, கூட்டாளரின் தலைகீழ் இறுதிப்புள்ளியை நோக்கிய ஒரு சகோதர ஒருங்கிணைப்பு வழியாக உண்மையான ஆப்-ACK ஐ வழங்குகிறது. முதலில் சகோதரத்தை தனி ஒருங்கிணைப்பு வரிசையாக உருவாக்கி, பின்னர் இங்கே இணைக்கவும்.",
      "outboundRouting": "இந்தப் பங்குதாரர் பெறுவது. எதுவும் தேர்ந்தெடுக்கப்படாவிட்டால், இந்த இடைமுகம் வெளிச்செல்லும் இலக்கு அல்ல; அதற்கு எந்தச் செய்தியும் அனுப்பப்படாது.",
      "outboundEvents": "விருப்பத்தேர்வு, காற்புள்ளியால் பிரிக்கவும். முழு வகையை விடக் குறுகியது — சில நிகழ்வுகளை மட்டும் விரும்பும் பங்குதாரருக்கு.",
      "receivingDefaults": "இங்கு அனுப்பப்படும் ஒவ்வொரு செய்தியிலும் பெறுநரை MSH-5 மற்றும் MSH-6 குறிக்கின்றன. காலியாக விட்டால் இடைமுகப் பெயர் பயன்படும்.",
      "inboundTrust": "நோயாளியின் அடையாளம் குறித்து இந்தப் பங்குதாரர் என்ன கூற முடியும். அங்கீகாரம் யார் இணைகிறார்கள் என்பதைக் கூறுகிறது; இந்த அமைப்பு அவர்கள் நமக்கு என்ன சொல்ல அனுமதிக்கப்படுகிறார்கள் என்பதைக் கூறுகிறது. இந்த இணைப்பு உண்மையிலேயே பதிவு முதன்மை அமைப்பாக இல்லாவிட்டால், வரிசைப்படுத்தல் இயல்புநிலையிலேயே விடவும்."
    },
    "option": {
      "type": {
        "mllp": "MLLP (TCP மீது HL7 v2)",
        "hoh": "HoH (HTTPS மீது HL7)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "கிளையன் (வெளிச்செல்லும்)",
        "server": "சேவையகம் (உள்வரும்)"
      },
      "method": {
        "none": "எதுவுமில்லை",
        "basic": "HTTP Basic",
        "bearer": "Bearer டோக்கன்",
        "clientCert": "கிளையன் சான்றிதழ் (mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "உடனடியாக AA (இன்றைய இயல்புநிலை)",
        "honorMsh16": "ஒவ்வொரு செய்திக்கும் MSH-15/16 ஐப் படிக்கவும்",
        "forceSync": "இன்லைனாக செயலாக்கவும், முடிவில் AA/AE/AR",
        "forceEnhanced": "இப்போது CA + தலைகீழ் சேனல் வழியாக ஆப்-ACK"
      },
      "outbound": {
        "fireAndForget": "அனுப்பிவிட்டு மறக்கவும் (இன்றைய இயல்புநிலை)",
        "expectSync": "MSH-16=AL அமைக்கவும், AE/AR இல் மறுமுயற்சி",
        "expectEnhanced": "CA க்காகக் காத்திருந்து தொடர் ஆப்-ACK"
      }
    },
    "validation": {
      "nameRequired": "பெயர் தேவை",
      "hostRequired": "ஹோஸ்ட் தேவை",
      "mllpPort": "MLLP ஒருங்கிணைப்புகளுக்கு ஒரு போர்ட் தேவை",
      "portNumber": "போர்ட் ஒரு எண்ணாக இருக்க வேண்டும்",
      "tlsServerCertKey": "TLS சேவையகத்திற்கு சான்றிதழ் மற்றும் விசை இரண்டும் தேவை",
      "basicUsername": "Basic அங்கீகாரத்திற்கு ஒரு பயனர்பெயர் தேவை",
      "basicPassword": "Basic அங்கீகாரத்திற்கு ஒரு கடவுச்சொல் தேவை",
      "bearerToken": "Bearer அங்கீகாரத்திற்கு ஒரு டோக்கன் தேவை",
      "enhancedReverse": "மேம்படுத்தப்பட்ட ACK பயன்முறைக்கு ஒரு தலைகீழ் ஒருங்கிணைப்பு தேவை — கீழே ஒன்றைத் தேர்ந்தெடுக்கவும்.",
      "outboundEvent": "\"{{value}}\" இந்த அமைப்பு அனுப்பும் செய்தி அல்ல — ADT போன்ற வகையையோ, ADT^A01 போன்ற நிகழ்வையோ பயன்படுத்தவும்."
    },
    "trust": {
      "useDeploymentDefault": "வரிசைப்படுத்தல் இயல்புநிலையைப் பயன்படுத்து",
      "observer": "பார்வையாளர் — நோயாளியை உருவாக்கவோ மாற்றவோ இல்லை",
      "demographics": "மக்கள்தொகை — நம்மிடம் உள்ள நோயாளியைத் திருத்தலாம், இறப்பு அறிவிப்பு உட்பட; உருவாக்காது",
      "registration": "பதிவு — நோயாளிகளை உருவாக்கவும் பதிவேடுகளை இணைக்கவும் முடியும்"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "பிம்பவியல்",
    "laboratory": "ஆய்வகம்",
    "pharmacy": "மருந்தகம்",
    "specialty": "சிறப்புத்துறை",
    "portal": "போர்ட்டல்",
    "billing": "கட்டணம்",
    "other": "மற்றவை"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "மறுவழியாக்கம்",
    "popup": "பாப்அப் சாளரம்",
    "iframe": "iframe",
    "newTab": "புதிய தாவல்"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "CDS விதியைத் திருத்து",
      "titleCreate": "CDS விதியை உருவாக்கு",
      "ruleName": "விதியின் பெயர்",
      "ruleType": "விதி வகை",
      "selectPlaceholder": "தேர்ந்தெடுக்கவும்…",
      "severity": "தீவிரம்",
      "triggerEvent": "தூண்டுதல் நிகழ்வு",
      "actionType": "செயல் வகை",
      "description": "விளக்கம்",
      "active": "செயலில்",
      "cancel": "ரத்துசெய்",
      "submitUpdate": "விதியைப் புதுப்பி",
      "submitCreate": "விதியை உருவாக்கு",
      "createdOk": "விதி வெற்றிகரமாக உருவாக்கப்பட்டது",
      "createFailed": "விதியை உருவாக்க முடியவில்லை",
      "updatedOk": "விதி வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது",
      "updateFailed": "விதியைப் புதுப்பிக்க முடியவில்லை",
      "validation": {
        "nameRequired": "விதியின் பெயர் தேவை",
        "typeRequired": "விதி வகை தேவை",
        "descriptionRequired": "விளக்கம் தேவை",
        "triggerRequired": "தூண்டுதல் நிகழ்வு தேவை",
        "actionRequired": "செயல் வகை தேவை"
      }
    },
    "list": {
      "title": "CDS விதிகள்",
      "subtitle": "மருத்துவ முடிவு ஆதரவு விதிகளை நிர்வகிக்கவும்",
      "addRule": "விதியைச் சேர்",
      "loading": "CDS விதிகள் ஏற்றப்படுகின்றன…",
      "loadError": "CDS விதிகளை ஏற்ற முடியவில்லை.",
      "empty": "CDS விதிகள் எதுவும் கட்டமைக்கப்படவில்லை.",
      "columns": {
        "ruleName": "விதியின் பெயர்",
        "type": "வகை",
        "severity": "தீவிரம்",
        "description": "விளக்கம்",
        "status": "நிலை",
        "actions": "செயல்கள்"
      },
      "toggleActive": "முடக்க கிளிக் செய்யவும்",
      "toggleInactive": "செயல்படுத்த கிளிக் செய்யவும்",
      "active": "செயலில்",
      "inactive": "செயலற்றது",
      "editRule": "விதியைத் திருத்து",
      "statusUpdated": "விதியின் நிலை புதுப்பிக்கப்பட்டது",
      "statusUpdateFailed": "விதியின் நிலையைப் புதுப்பிக்க முடியவில்லை"
    }
  },
  "cdsSeverity": {
    "info": "தகவல்",
    "warning": "எச்சரிக்கை",
    "critical": "தீவிரம்"
  },
  "cdsTriggerEvent": {
    "orderSign": "ஆணை கையொப்பம்",
    "orderSelect": "ஆணை தேர்வு",
    "patientView": "நோயாளர் பார்வை",
    "medicationPrescribe": "மருந்து பரிந்துரை",
    "resultReceived": "முடிவு பெறப்பட்டது",
    "patientAdmit": "நோயாளர் அனுமதி"
  },
  "cdsActionType": {
    "alert": "விழிப்பூட்டல்",
    "warning": "எச்சரிக்கை",
    "hardStop": "கடும் நிறுத்தம்",
    "suggestion": "பரிந்துரை",
    "notification": "அறிவிப்பு"
  },
  "cdsRuleType": {
    "drugInteraction": "மருந்து இடைவினை",
    "drugAllergy": "மருந்து ஒவ்வாமை",
    "duplicateOrder": "நகல் ஆர்டர்",
    "custom": "தனிப்பயன்",
    "clinicalAlert": "மருத்துவ எச்சரிக்கை",
    "sepsisScreen": "செப்சிஸ் பரிசோதனை"
  },
  "system": {
    "title": "கணினி அமைப்பு",
    "subtitle": "பயன்பாட்டு அமைப்புகள், பாதுகாப்பு மற்றும் கணினி நலன்",
    "restartServices": "சேவைகளை மறுதொடக்கம் செய்",
    "restartToast": "சேவைகளை மறுதொடக்கம் செய் (இடப்பிடிப்பு - உறுதிப்படுத்தல் தேவை)",
    "loadError": "கணினி அமைப்பை ஏற்ற முடியவில்லை",
    "section": {
      "systemInfo": "கணினி தகவல்",
      "systemInfoDesc": "பதிப்பு, இயக்க நேரம் மற்றும் சேவை நலன்",
      "general": "பொது அமைப்புகள்",
      "generalDesc": "பயன்பாட்டுப் பெயர், நேர மண்டலம் மற்றும் வடிவமைப்பு",
      "security": "பாதுகாப்பு அமைப்புகள்",
      "securityDesc": "கடவுச்சொல் கொள்கை, MFA மற்றும் அமர்வு மேலாண்மை",
      "notifications": "அறிவிப்பு அமைப்புகள்",
      "notificationsDesc": "மின்னஞ்சல் மற்றும் SMS நுழைவாயில் கட்டமைப்பு",
      "integration": "ஒருங்கிணைப்பு இயல்புநிலைகள்",
      "integrationDesc": "MLLP, FHIR மற்றும் HL7 இயல்புநிலை கட்டமைப்பு",
      "featureFlags": "அம்ச கொடிகள்",
      "featureFlagsDesc": "கணினி அம்சங்களை இயக்கு அல்லது முடக்கு",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "பதிப்பு",
      "uptime": "இயக்க நேரம்",
      "database": "தரவுத்தளம்",
      "redis": "Redis",
      "microservices": "நுண்சேவைகள்",
      "conn": "இணைப்பு"
    },
    "uptime": {
      "running": "இயங்குகிறது",
      "unknown": "தெரியவில்லை",
      "up": "செயலில்"
    },
    "subsection": {
      "passwordPolicy": "கடவுச்சொல் கொள்கை",
      "mfa": "பல்காரணி அங்கீகாரம்",
      "sessionLockout": "அமர்வு மற்றும் பூட்டுதல்",
      "emailConfig": "மின்னஞ்சல் கட்டமைப்பு",
      "smsGateway": "SMS நுழைவாயில்",
      "mllpDefaults": "MLLP இயல்புநிலைகள்",
      "fhirConfig": "FHIR கட்டமைப்பு",
      "hl7Encoding": "HL7 v2 குறியாக்கம்"
    },
    "fields": {
      "appName": "பயன்பாட்டுப் பெயர்",
      "timezone": "நேர மண்டலம்",
      "dateFormat": "தேதி வடிவம்",
      "supportEmail": "ஆதரவு மின்னஞ்சல்",
      "logoUrl": "லோகோ URL",
      "maintenanceMode": "பராமரிப்பு பயன்முறை (பயனர் அணுகலை முடக்குகிறது)",
      "upload": "பதிவேற்று",
      "minPasswordLength": "குறைந்தபட்ச கடவுச்சொல் நீளம்",
      "passwordExpiry": "கடவுச்சொல் காலாவதி (நாட்கள்)",
      "requireUppercase": "பெரிய எழுத்து தேவை",
      "requireNumbers": "எண்கள் தேவை",
      "requireSpecialChars": "சிறப்பு எழுத்துகள் தேவை",
      "enableMfa": "MFA ஐ இயக்கு",
      "mfaMethod": "MFA முறை",
      "sessionTimeout": "அமர்வு நேரம் முடிவு (நிமிடம்)",
      "maxLoginAttempts": "அதிகபட்ச உள்நுழைவு முயற்சிகள்",
      "lockoutDuration": "பூட்டுதல் கால அளவு (நிமிடம்)",
      "smtpHost": "SMTP ஹோஸ்ட்",
      "smtpPort": "SMTP முனையம்",
      "smtpUser": "SMTP பயனர்",
      "fromEmail": "அனுப்புநர் மின்னஞ்சல்",
      "useTls": "TLS ஐப் பயன்படுத்து",
      "enabled": "இயக்கப்பட்டது",
      "provider": "வழங்குநர்",
      "fromNumber": "அனுப்புநர் எண்",
      "defaultPort": "இயல்புநிலை முனையம்",
      "timeoutSeconds": "நேரம் முடிவு (வினாடிகள்)",
      "retryCount": "மறுமுயற்சி எண்ணிக்கை",
      "fhirBaseUrl": "FHIR அடிப்படை URL",
      "authMethod": "அங்கீகார முறை",
      "fieldSeparator": "புலப் பிரிப்பான்",
      "encodingChars": "குறியாக்க எழுத்துகள்",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "ஆசியா/சிங்கப்பூர் (UTC+8)",
        "hongKong": "ஆசியா/ஹாங்காங் (UTC+8)",
        "kualaLumpur": "ஆசியா/கோலாலம்பூர் (UTC+8)",
        "bangkok": "ஆசியா/பாங்காக் (UTC+7)",
        "tokyo": "ஆசியா/டோக்கியோ (UTC+9)",
        "kolkata": "ஆசியா/கொல்கத்தா (UTC+5:30)",
        "sydney": "ஆஸ்திரேலியா/சிட்னி (UTC+11)"
      },
      "mfa": {
        "totp": "TOTP (அங்கீகரிப்பு பயன்பாடு)",
        "sms": "SMS",
        "email": "மின்னஞ்சல்"
      },
      "fhirAuth": {
        "none": "எதுவுமில்லை",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "பொது அமைப்புகளைச் சேமி",
      "security": "பாதுகாப்பு அமைப்புகளைச் சேமி",
      "notifications": "அறிவிப்பு அமைப்புகளைச் சேமி",
      "integration": "ஒருங்கிணைப்பைச் சேமி",
      "features": "அம்ச கொடிகளைச் சேமி",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "பொது",
      "security": "பாதுகாப்பு",
      "notifications": "அறிவிப்பு",
      "integration": "ஒருங்கிணைப்பு",
      "features": "அம்ச கொடிகள்",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "லோகோவைப் பதிவேற்று (இடப்பிடிப்பு)",
      "saved": "{{section}} அமைப்புகள் வெற்றிகரமாகச் சேமிக்கப்பட்டன",
      "saveFailed": "அமைப்புகளைச் சேமிக்க முடியவில்லை"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "நோயாளி ஒன்றிணைப்பு",
        "description": "நோயாளி ஒன்றிணைப்பு/பிரித்தல் செயல்பாட்டை இயக்கு"
      },
      "breakGlass": {
        "label": "அவசர அணுகல்",
        "description": "கட்டுப்படுத்தப்பட்ட பதிவுகளுக்கு அவசர மேலெழுதலை அனுமதி"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "வெளி அமைப்புகளுக்கு FHIR R4 இறுதிப்புள்ளிகளை வெளிப்படுத்து"
      },
      "smartApps": {
        "label": "SMART on FHIR பயன்பாடுகள்",
        "description": "மூன்றாம் தரப்பு SMART பயன்பாடுகள் இணைய அனுமதி"
      },
      "clinicalDecisionSupport": {
        "label": "மருத்துவ முடிவு ஆதரவு",
        "description": "ஆர்டர் உள்ளீட்டுக்கு CDS கொக்கிகளை இயக்கு"
      },
      "telemedicine": {
        "label": "தொலைமருத்துவ தொகுதி",
        "description": "வீடியோ ஆலோசனை மற்றும் தொலைநிலை கண்காணிப்பு"
      },
      "patientPortal": {
        "label": "நோயாளி இணையதளம்",
        "description": "பதிவுகள் மற்றும் சந்திப்புகளுக்கான நோயாளி இணையதளம்"
      },
      "analyticsDashboard": {
        "label": "பகுப்பாய்வு டாஷ்போர்டு",
        "description": "மேம்பட்ட பகுப்பாய்வு மற்றும் அறிக்கை டாஷ்போர்டுகள்"
      },
      "medicationBarcode": {
        "label": "மருந்து பார்கோடு ஸ்கேனிங்",
        "description": "மருந்து வழங்கலுக்கான பார்கோடு சரிபார்ப்பு"
      },
      "autoCoding": {
        "label": "தானியங்கி குறியாக்கம் (ICD/CPT)",
        "description": "AI-உதவி நோயறிதல் மற்றும் செயல்முறை குறியாக்கம்"
      }
    }
  },
  "audit": {
    "title": "தணிக்கைப் பதிவு",
    "subtitle": "விரிவான மாற்றக் கண்காணிப்புடன் கூடிய அமைப்புச் செயல்பாட்டுப் பதிவு",
    "exportCsv": "CSV ஏற்றுமதி",
    "exportToast": "{{count}} தணிக்கை உள்ளீடுகள் CSV ஆக ஏற்றுமதி செய்யப்படுகிறது (இடம்பிடி)",
    "searchPlaceholder": "பயனர் மூலம் தேடு…",
    "advanced": "மேம்பட்டது",
    "breakGlassOnly": "அவசர அணுகல் மட்டும்",
    "fromTo": "முதல் / வரை:",
    "fromDate": "தொடக்க தேதி",
    "toDate": "முடிவு தேதி",
    "clearFilters": "அனைத்து வடிப்பான்களையும் அழி",
    "entriesFound": "{{count}} உள்ளீடுகள் கண்டறியப்பட்டன",
    "noMatch": "உங்கள் வடிப்பான்களுடன் பொருந்தும் தணிக்கை உள்ளீடுகள் இல்லை",
    "viewDetails": "விவரங்களைக் காண்க",
    "detail": {
      "title": "தணிக்கை உள்ளீட்டு விவரம்",
      "timestamp": "நேர முத்திரை",
      "user": "பயனர்",
      "action": "செயல்",
      "resource": "வளம்",
      "ipAddress": "IP முகவரி",
      "breakGlass": "அவசர அணுகல்",
      "yes": "ஆம்",
      "no": "இல்லை",
      "details": "விவரங்கள்",
      "dataChanges": "தரவு மாற்றங்கள்",
      "before": "முன்",
      "after": "பின்",
      "result": "முடிவு"
    },
    "columns": {
      "timestamp": "நேர முத்திரை",
      "user": "பயனர்",
      "action": "செயல்",
      "resource": "வளம்",
      "resourceId": "வள ID",
      "ipAddress": "IP முகவரி",
      "details": "விவரங்கள்",
      "view": "காண்க"
    },
    "filter": {
      "action": {
        "all": "அனைத்துச் செயல்கள்",
        "create": "உருவாக்கு",
        "read": "படி",
        "update": "புதுப்பி",
        "delete": "நீக்கு",
        "login": "உள்நுழைவு",
        "logout": "வெளியேறு",
        "export": "ஏற்றுமதி",
        "breakGlass": "அவசர அணுகல்"
      },
      "resource": {
        "all": "அனைத்து வளங்கள்",
        "patient": "நோயாளி",
        "encounter": "சந்திப்பு",
        "order": "உத்தரவு",
        "result": "முடிவு",
        "medication": "மருந்து",
        "user": "பயனர்",
        "system": "அமைப்பு"
      }
    },
    "pagination": {
      "first": "முதல்",
      "last": "கடைசி",
      "pageOf": "பக்கம் {{page}} / {{pages}}",
      "range": "{{total}} இல் {{from}}-{{to}}"
    }
  },
  "taxonomy": {
    "title": "மருத்துவ வகைப்பாட்டியல்",
    "subtitle": "சேவை வரிசைகள் தொடர்புடைய மருத்துவ சேவைகளைக் குழுவாக்குகின்றன (Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic). இரண்டும் கால அட்டவணைப்படுத்தலில் பயன்படுத்தப்படும் சேவை ↔ இடம் ஒதுக்கீட்டு அணிக்கு உள்ளீடாகும்.",
    "addServiceLine": "சேவை வரிசையைச் சேர்",
    "addClinicalService": "மருத்துவ சேவையைச் சேர்",
    "tabs": {
      "serviceLines": "சேவை வரிசைகள்",
      "clinicalServices": "மருத்துவ சேவைகள்"
    },
    "searchLines": "சேவை வரிசைகளைத் தேடு...",
    "searchServices": "மருத்துவ சேவைகளைத் தேடு...",
    "empty": {
      "linesNone": "சேவை வரிசைகள் எதுவும் கட்டமைக்கப்படவில்லை.",
      "linesNoMatch": "பொருந்தும் சேவை வரிசை எதுவும் இல்லை.",
      "servicesNone": "மருத்துவ சேவைகள் எதுவும் கட்டமைக்கப்படவில்லை.",
      "servicesNoMatch": "பொருந்தும் மருத்துவ சேவை எதுவும் இல்லை."
    },
    "columns": {
      "name": "பெயர்",
      "code": "குறியீடு",
      "description": "விளக்கம்",
      "services": "சேவைகள்",
      "status": "நிலை",
      "serviceLine": "சேவை வரிசை",
      "specialty": "சிறப்புத்துறை",
      "actions": "செயல்கள்"
    },
    "status": {
      "active": "செயலில்",
      "inactive": "செயலற்ற"
    },
    "editTitle": "திருத்து"
  },
  "systemStatus": {
    "connected": "இணைக்கப்பட்டது",
    "error": "பிழை"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}} பேர் நியமிக்கப்பட்டுள்ளனர்",
      "unstaffedBadge": "யாரும் இல்லை",
      "unstaffedWarning": "இந்தப் பணிகளுக்கு யாரும் நியமிக்கப்படவில்லை, எனவே அந்த நிலைகள் யாரையும் அழைக்காது: {{roles}}. நிர்வாகம் → பயனர்கள் பகுதியில் பணியை ஊழியருக்கு ஒதுக்கவும்."
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
